/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ActiveCampaignStatus {
  connected: boolean;
  accountUrl?: string;
  lastError?: string;
  lastSyncAt?: string;
}

export interface ActiveCampaignConnectRequest {
  accountUrl: string;
  apiKey: string;
}

export interface ActiveCampaignList {
  id: string;
  name: string;
}

export enum ActiveCampaignTriggerScope {
  All = 'all',
  PublicOnly = 'publicOnly',
}

export interface ActiveCampaignConfig {
  id: string;
  questionnaireId: string;
  acListId: string;
  acTag: string;
  triggerScope: ActiveCampaignTriggerScope;
  enabled: boolean;
  lastSyncAt?: string;
  lastError?: string;
}

export interface ActiveCampaignConfigRequest {
  questionnaireId: string;
  acListId: string;
  acTag: string;
  triggerScope: ActiveCampaignTriggerScope;
  enabled: boolean;
}

/** Construct a type with a set of properties K of type T */
export interface RecordSupportedLanguageString {
  en?: string;
  nl?: string;
}

export enum AdviceType {
  CustomerAdvice = 'customerAdvice',
  EmployeeAdvice = 'employeeAdvice',
}

export interface AdviceContent {
  id?: string;
  image: string;
  /** Construct a type with a set of properties K of type T */
  advice?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  audioUrl?: RecordSupportedLanguageString;
}

export interface Advice {
  id: string;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  type: AdviceType;
  salonId: string;
  adviceGroupId: string;
  adviceConditionsIds: string[];
  adviceContent: AdviceContent[];
  /** @format double */
  order: number;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: string;
}

export interface AdviceGroup {
  id: string;
  name: string;
  salonId: string;
}

export enum ConditionValueOption {
  ValueAnyText = '<any_text>',
}

export interface AdviceConditionOption {
  questionnaireId: string;
  questionId: string;
  value: string | ConditionValueOption;
}

export interface AdviceCondition {
  id: string;
  name: string;
  description?: string;
  salonId: string;
  conditions: AdviceConditionOption[];
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickAdviceExcludeKeysIdOrSalonIdOrDeletedAtOrDeletedByOrAdviceContent {
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  type: AdviceType;
  adviceGroupId: string;
  adviceConditionsIds: string[];
  /** @format double */
  order: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitAdviceIdOrSalonIdOrDeletedAtOrDeletedByOrAdviceContent =
  PickAdviceExcludeKeysIdOrSalonIdOrDeletedAtOrDeletedByOrAdviceContent;

/** From T, pick a set of properties whose keys are in the union K */
export interface PickAdviceContentExcludeKeysId {
  image: string;
  /** Construct a type with a set of properties K of type T */
  advice?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  audioUrl?: RecordSupportedLanguageString;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitAdviceContentId = PickAdviceContentExcludeKeysId;

export type AdviceContentCreate = OmitAdviceContentId;

export type AdviceCreateRequest = OmitAdviceIdOrSalonIdOrDeletedAtOrDeletedByOrAdviceContent & {
  adviceContent: AdviceContentCreate[];
};

/** From T, pick a set of properties whose keys are in the union K */
export interface PickAdviceGroupExcludeKeysIdOrSalonId {
  name: string;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitAdviceGroupIdOrSalonId = PickAdviceGroupExcludeKeysIdOrSalonId;

export type AdviceGroupCreateRequest = OmitAdviceGroupIdOrSalonId;

/** From T, pick a set of properties whose keys are in the union K */
export interface PickAdviceConditionExcludeKeysIdOrSalonId {
  name: string;
  description?: string;
  conditions: AdviceConditionOption[];
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitAdviceConditionIdOrSalonId = PickAdviceConditionExcludeKeysIdOrSalonId;

export type AdviceConditionCreateRequest = OmitAdviceConditionIdOrSalonId;

export interface ReorderRequest {
  elements: {
    /** @format double */
    order: number;
    id: string;
  }[];
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickAdviceExcludeKeysIdOrSalonIdOrDeletedAtOrDeletedBy {
  adviceContent: AdviceContent[];
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  type: AdviceType;
  adviceGroupId: string;
  adviceConditionsIds: string[];
  /** @format double */
  order: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitAdviceIdOrSalonIdOrDeletedAtOrDeletedBy = PickAdviceExcludeKeysIdOrSalonIdOrDeletedAtOrDeletedBy;

export type AdviceUpdateRequest = OmitAdviceIdOrSalonIdOrDeletedAtOrDeletedBy & {
  deleted: boolean;
};

export type AdviceGroupUpdateRequest = OmitAdviceGroupIdOrSalonId;

export type AdviceConditionUpdateRequest = OmitAdviceConditionIdOrSalonId;

export enum SupportedLanguage {
  En = 'en',
  Nl = 'nl',
}

export enum UserTypeAffiliate {
  Affiliate = 'affiliate',
}

export enum DiscountType {
  Percent = 'percent',
  Fixed = 'fixed',
}

export interface DiscountConfig {
  /** @format double */
  value: number;
  type: DiscountType;
}

export interface AffiliateUserCommission {
  /** @format double */
  subscriptionOptionCost: number;
  subscriptionOptionId: string;
  organisationEmployeeId: string;
  organisationId: string;
  confirmed: boolean;
  withdrawn: boolean;
  /** @format double */
  amount: number;
  /** @format date-time */
  createdAt: string;
  id: string;
}

export interface AffiliateUserCommissionWithdrawal {
  /** @format date-time */
  paidOutAt?: string;
  paidOut: boolean;
  commissionIds: string[];
  /** @format date-time */
  createdAt: string;
  id: string;
}

export interface AffiliateUserBankDetails {
  postalCode: string;
  city: string;
  country: string;
  streetAddress: string;
  bankName: string;
  swiftCode: string;
  countryCode: string;
  iban: string;
  fullName: string;
}

export interface AffiliateUser {
  bankDetails?: AffiliateUserBankDetails;
  withdrawals: AffiliateUserCommissionWithdrawal[];
  commissions: AffiliateUserCommission[];
  /** @format double */
  commissionPercentage: number;
  discountCode: {
    discount: DiscountConfig;
    code: string;
  };
  deleted: boolean;
  type: UserTypeAffiliate;
  language: SupportedLanguage;
  name: string;
  email: string;
  id: string;
}

export interface AffiliateInviteRequest {
  discount: DiscountConfig;
  /** @format double */
  commissionPercentage: number;
  name: string;
  language: SupportedLanguage;
  email: string;
}

export interface AffiliateUserUpdateRequest {
  deleted: boolean;
  bankDetails?: AffiliateUserBankDetails;
  discount: DiscountConfig;
  /** @format double */
  commissionPercentage: number;
  code: string;
  name: string;
  language: SupportedLanguage;
  email: string;
}

export interface AffiliateUserPasswordResetRequest {
  password: string;
  userId: string;
  confirmationCode: string;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickAffiliateUserUpdateRequestExcludeKeysEmailOrCommissionPercentageOrDiscount {
  name: string;
  language: SupportedLanguage;
  code: string;
  bankDetails?: AffiliateUserBankDetails;
  deleted: boolean;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitAffiliateUserUpdateRequestEmailOrCommissionPercentageOrDiscount =
  PickAffiliateUserUpdateRequestExcludeKeysEmailOrCommissionPercentageOrDiscount;

export type CurrentAffiliateUserUpdateRequest = OmitAffiliateUserUpdateRequestEmailOrCommissionPercentageOrDiscount & {
  currentPassword?: string;
  newPassword?: string;
};

export interface AffiliateUserJwtClaims {
  token: string;
  type: UserTypeAffiliate;
  email: string;
  id: string;
}

export interface AiSkill {
  id: string;
  key: string;
  name: string;
  description?: string;
  instruction: string;
}

export interface AiSkillCreateRequest {
  key: string;
  name: string;
  description?: string;
  instruction: string;
}

export interface AiSkillUpdateRequest {
  name: string;
  description?: string;
  instruction: string;
}

export enum AppointmentMatchStatus {
  Matched = 'matched',
  Unmatched = 'unmatched',
  Ambiguous = 'ambiguous',
  NoAttendee = 'no-attendee',
}

export interface AppointmentOverview {
  id: string;
  date: string;
  startTime?: string;
  endTime?: string;
  summary?: string;
  matchStatus: AppointmentMatchStatus;
  matchedCustomerId?: string;
  matchedCustomerName?: string;
  voorzorgSentAt?: string;
  nazorgSentAt?: string;
  voorzorgSubmissionId?: string;
  nazorgSubmissionId?: string;
}

export enum PaymentStatus {
  Open = 'open',
  Canceled = 'canceled',
  Pending = 'pending',
  Authorized = 'authorized',
  Expired = 'expired',
  Failed = 'failed',
  Paid = 'paid',
}

export interface Payment {
  discountCode?: string;
  courseId?: string;
  assistantCreditsOptionId?: string;
  whatsappCreditsOptionId?: string;
  subscriptionOptionExtrasIds?: string[];
  subscriptionOptionId?: string;
  invoiceId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  paidAt?: string;
  userId?: string;
  /** @format double */
  amount: number;
  name: string;
  status: PaymentStatus;
  paymentId: string;
}

export interface AssistantCreditsPaymentCreateResponse {
  checkoutUrl: string;
  payment: Payment;
}

export interface AssistantCreditsPaymentCreateRequest {
  assistantCreditsOptionId: string;
}

export interface AssistantCreditsOption {
  /** @format double */
  count: number;
  /** @format double */
  cost: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  id: string;
}

export interface Assistant {
  questionnaires: {
    questionIds: string[];
    questionnaireId: string;
  }[];
  /** @format double */
  creditsCost: number;
  description: string;
  name: string;
  id: string;
}

export interface GenerateAssistantAdviceRequest {
  userId: string;
  assistantId: string;
}

export interface AssistantAdvice {
  /** @format date-time */
  createdAt: string;
  advice: string;
  salonId: string;
  userId: string;
  assistantName: string;
  assistantId: string;
  id: string;
}

export interface UpdateAssistantAdviceRequest {
  advice: string;
}

export interface UpdateSelectedAssistantsRequest {
  salons: {
    assistantsIds: string[];
    id: string;
  }[];
}

export interface GlobalAssistant {
  files: {
    fileName: string;
    fileUrl: string;
  }[];
  questionnaires: {
    questionIds: string[];
    questionnaireId: string;
  }[];
  description: string;
  instructions: string;
  /** @format double */
  creditsCost: number;
  modelName: string;
  name: string;
  id: string;
}

export interface AssistantCreateRequest {
  files: {
    fileName: string;
    fileUrl: string;
  }[];
  questionnaires: {
    questionIds: string[];
    questionnaireId: string;
  }[];
  /** @format double */
  creditsCost: number;
  description: string;
  instructions: string;
  modelName: string;
  name: string;
}

export type AssistantUpdateRequest = AssistantCreateRequest;

export enum UserTypeCustomer {
  Customer = 'customer',
}

export interface CustomerJwtClaims {
  language: SupportedLanguage;
  token: string;
  organisationId: string;
  type: UserTypeCustomer;
  email: string;
  id: string;
}

export enum UserTypeEmployee {
  Employee = 'employee',
}

export interface EmployeeJwtClaims {
  token: string;
  organisationId: string;
  type: UserTypeEmployee;
  email: string;
  id: string;
}

export interface EmployeePasswordResetRequest {
  confirmationCode: string;
  userId: string;
  password: string;
}

export enum UserTypeGlobalAdmin {
  GlobalAdmin = 'globalAdmin',
}

export interface GlobalAdminJwtClaims {
  token: string;
  type: UserTypeGlobalAdmin;
  username: string;
  id: string;
}

export interface ImpersonateEmployeeRequest {
  email: string;
  organisationId: string;
}

export enum CustomerCommentType {
  Treatment = 'Treatment',
  Products = 'Products',
  SkinPlan = 'SkinPlan',
  OnPoint = 'OnPoint',
}

export interface CustomerComment {
  /** @format date-time */
  deletedAt?: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  createdAt: string;
  createdBy: string;
  content: string;
  type: CustomerCommentType;
  id: string;
}

export interface CustomerCommentCreateRequest {
  content: string;
  type: CustomerCommentType;
}

export type CustomerCommentUpdateRequest = CustomerCommentCreateRequest;

export enum CustomerGender {
  Male = 'male',
  Female = 'female',
  Undefined = 'undefined',
}

export enum OrganisationMessagingType {
  Email = 'email',
  Whatsapp = 'whatsapp',
}

export interface CustomerUserDetails {
  allowedMessagingTypes: OrganisationMessagingType[];
  messagingType?: OrganisationMessagingType;
  profileImage?: string;
  language: SupportedLanguage;
  notes?: string;
  gender?: CustomerGender;
  /** @format date-time */
  dateOfBirth?: string;
  city?: string;
  zipcode?: string;
  address?: string;
  phoneNumber2?: string;
  phoneNumber?: string;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringUnknown = object;

export interface SneladviesNote {
  senderName?: string;
  createdAt: string;
  text: string;
}

export interface CustomerUser {
  type: UserTypeCustomer;
  createdAt?: string;
  deletedBy?: string;
  /** @format date-time */
  deletedAt?: string;
  treatmentAnalysisAt?: string;
  treatmentAnalysisTraject?: string;
  treatmentAnalysis?: string;
  sneladviesNotes?: SneladviesNote[];
  sneladviesBlockIds?: string[];
  spokenEmployeeClassifications?: {
    classificationKey: string;
    employeeId: string;
  }[];
  spokenCustomerClassification?: string;
  /** Construct a type with a set of properties K of type T */
  customFields: RecordStringUnknown;
  details: CustomerUserDetails;
  name: string;
  email: string;
  accessibleSalons: string[];
  organisationId: string;
  id: string;
}

export interface CustomerCreateRequest {
  email: string;
  name: string;
  salonIds: string[];
  details: CustomerUserDetails;
  customFields: any;
}

export interface CurrentCustomerUpdateRequest {
  name: string;
  details: CustomerUserDetails;
}

export enum DocumentType {
  Document = 'document',
  ConsentForm = 'consentForm',
  PdfDocument = 'pdfDocument',
}

export enum CustomerConsentStatus {
  NotSeen = 'notSeen',
  Seen = 'seen',
  Accepted = 'accepted',
  Declined = 'declined',
}

export interface CurrentCustomerDocument {
  form: {
    /** Construct a type with a set of properties K of type T */
    pdfUrl: RecordSupportedLanguageString;
    /** Construct a type with a set of properties K of type T */
    text: RecordSupportedLanguageString;
    /** Construct a type with a set of properties K of type T */
    name: RecordSupportedLanguageString;
  };
  /** @format date-time */
  consentStatusUpdatedAt?: string;
  consentStatus?: CustomerConsentStatus;
  documentId: string;
  type: DocumentType;
  /** @format date-time */
  createdAt: string;
  id: string;
}

export enum CustomerActivityType {
  SubmissionCreated = 'submissionCreated',
  AnswerUpdated = 'answerUpdated',
  Login = 'login',
  FailedLogin = 'failedLogin',
  CodeRequest = 'codeRequest',
  ProfileUpdate = 'profileUpdate',
  DocumentStatusUpdated = 'documentStatusUpdated',
  DocumentSent = 'documentSent',
  DocumentDelete = 'documentDelete',
}

export enum UserType {
  Customer = 'customer',
  Employee = 'employee',
  GlobalAdmin = 'globalAdmin',
  Affiliate = 'affiliate',
}

export enum QuestionnaireSubmissionCreationBasis {
  Email = 'email',
  WhatsApp = 'whatsApp',
  InApp = 'inApp',
}

export interface CustomerActivity {
  id: string;
  userId: string;
  data: {
    documentDelete?: {
      deletedBy: string;
      email: string;
      documentName: string;
      documentId: string;
    };
    documentSent?: {
      sentBy: string;
      email: string;
      documentName: string;
      documentId: string;
    };
    documentStatusUpdated?: {
      status: CustomerConsentStatus;
      documentName: string;
      documentId: string;
    };
    profileUpdate?: {
      updatedByUserType: UserType;
      updatedBy: string;
      data: {
        customFields: any;
        details: CustomerUserDetails;
        salonIds: string[];
        deleted: boolean;
        email: string;
        name: string;
      };
    };
    codeRequest?: {
      email: string;
    };
    failedLogin?: {
      email: string;
    };
    login?: {
      email: string;
    };
    submissionCreated?: {
      createdBy: string;
      targetPhoneNumber?: string;
      targetEmail?: string;
      creationBasis: QuestionnaireSubmissionCreationBasis;
      questionnaireSubmissionId: string;
    };
    answerUpdated?: {
      answeredByUserType: UserType;
      answeredBy: string;
      answer: string[];
      questionId: string;
      questionnaireSubmissionId: string;
    };
    activityType: CustomerActivityType;
  };
  /** @format date-time */
  createdAt: string;
}

export interface CustomerEditRequest {
  name: string;
  email: string;
  deleted: boolean;
  salonIds: string[];
  details: CustomerUserDetails;
  customFields: any;
}

export interface CustomerDocument {
  /** @format date-time */
  consentStatusUpdatedAt?: string;
  consentStatus?: CustomerConsentStatus;
  /** @format date-time */
  sentAt: string;
  sentBy: string;
  salonId: string;
  documentId: string;
  userId: string;
  id: string;
}

export interface QuestionnaireSubmissionNotification {
  type: OrganisationMessagingType;
}

export interface SendCustomerDocumentRequest {
  notificationToSend: QuestionnaireSubmissionNotification;
  documentId: string;
}

export interface CustomersSearchRequest {
  salonIds: string[];
  containingText?: string;
  showDeleted: boolean;
  customFieldPropertyNames?: string[];
}

export interface CustomersBulkCreateRequest {
  customers: CustomerCreateRequest[];
}

export interface SendAdviceNotificationRequest {
  salonId: string;
}

export enum QuestionnaireDashboardTypeWishes {
  Wishes = 'Wishes',
}

export enum MappingElementLabelWidth {
  Default = 'Default',
  Short = 'Short',
  Long = 'Long',
  Max = 'Max',
}

export interface BaseMappingElement {
  labelWidth?: MappingElementLabelWidth;
  labelPostfix?: string;
  labelPosition: string;
  image?: string;
  questionId?: string;
  questionnaireId?: string;
  elementName: string;
  groupName: string;
}

export enum MappingElementTypeConditional {
  Conditional = 'Conditional',
}

export type ConditionalMappingElement = BaseMappingElement & {
  value: string | ConditionValueOption;
  type: MappingElementTypeConditional;
};

export enum MappingElementTypeDirect {
  Direct = 'Direct',
}

export type DirectMappingElement = BaseMappingElement & {
  type: MappingElementTypeDirect;
};

export enum MappingElementTypePersistent {
  Persistent = 'Persistent',
}

export type PersistentMappingElement = BaseMappingElement & {
  type: MappingElementTypePersistent;
};

export type MappingElement = ConditionalMappingElement | DirectMappingElement | PersistentMappingElement;

export interface WishesDashboardConfiguration {
  elements: MappingElement[];
  type: QuestionnaireDashboardTypeWishes;
  id: string;
}

export enum QuestionnaireDashboardTypeWishes2 {
  Wishes2 = 'Wishes2',
}

export interface Wishes2DashboardConfiguration {
  elements: MappingElement[];
  type: QuestionnaireDashboardTypeWishes2;
  id: string;
}

export enum QuestionnaireDashboardTypeSkin {
  Skin = 'Skin',
}

export interface SkinDashboardConfiguration {
  elements: MappingElement[];
  type: QuestionnaireDashboardTypeSkin;
  id: string;
}

export enum QuestionnaireDashboardTypeVitality {
  Vitality = 'Vitality',
}

export interface VitalityDashboardConfiguration {
  elements: MappingElement[];
  type: QuestionnaireDashboardTypeVitality;
  id: string;
}

export type DashboardConfiguration =
  | WishesDashboardConfiguration
  | Wishes2DashboardConfiguration
  | SkinDashboardConfiguration
  | VitalityDashboardConfiguration;

export enum QuestionnaireDashboardType {
  Wishes = 'Wishes',
  Wishes2 = 'Wishes2',
  Skin = 'Skin',
  Vitality = 'Vitality',
}

export enum MappingElementType {
  Direct = 'Direct',
  Conditional = 'Conditional',
  Persistent = 'Persistent',
}

export interface MappingElementUpdateType {
  labelWidth?: MappingElementLabelWidth;
  labelPostfix?: string;
  labelPosition: string;
  image?: string;
  questionId?: string;
  questionnaireId?: string;
  groupName: string;
  elementName: string;
  value?: string;
  type: MappingElementType;
}

export interface DashboardConfigurationUpdateType {
  elements?: MappingElementUpdateType[];
  id?: string;
  type: QuestionnaireDashboardType;
}

export interface DashboardConfigurationsUpdateRequest {
  configurations: DashboardConfigurationUpdateType[];
}

export interface Document {
  deletedBy?: string;
  /** @format date-time */
  deletedAt?: string;
  type: DocumentType;
  /** Construct a type with a set of properties K of type T */
  pdfUrl?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  text: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  id: string;
}

export interface DocumentCreateRequest {
  type: DocumentType;
  /** Construct a type with a set of properties K of type T */
  pdfUrl?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  text: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
}

export interface DocumentUpdateRequest {
  deleted: boolean;
  /** Construct a type with a set of properties K of type T */
  pdfUrl?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  text?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
}

export interface EmployeeSalonAccessPermissions {
  salonId: string;
  assignedSalonRoles: string[];
}

export enum OrganisationPermissionType {
  OwnOrganisation = 'ownOrganisation',
  ReadSubscription = 'readSubscription',
  ManageSubscription = 'manageSubscription',
  ReadSalons = 'readSalons',
  ManageSalons = 'manageSalons',
  ManagePermissions = 'managePermissions',
  ManageTrainings = 'manageTrainings',
  ManageDocuments = 'manageDocuments',
}

export interface EmployeeUser {
  treatsCustomers?: boolean;
  organisationPermissions: OrganisationPermissionType[];
  salonsAccess: EmployeeSalonAccessPermissions[];
  language: SupportedLanguage;
  displayName?: string;
  deletedBy?: string;
  /** @format date-time */
  deletedAt?: string;
  type: UserTypeEmployee;
  email: string;
  organisationId: string;
  id: string;
}

export enum EmployeeActivityType {
  Login = 'login',
  FailedLogin = 'failedLogin',
  PasswordResetRequest = 'passwordResetRequest',
  SuccessfulPasswordReset = 'successfulPasswordReset',
  CustomerCommentAdd = 'customerCommentAdd',
  CustomerCommentUpdate = 'customerCommentUpdate',
  CustomerCommentDelete = 'customerCommentDelete',
  CustomerCreate = 'customerCreate',
  CustomerUpdate = 'customerUpdate',
  CustomersSearch = 'customersSearch',
  CustomersImport = 'customersImport',
  CustomerHardDelete = 'customerHardDelete',
  DashboardConfigurationUpdate = 'dashboardConfigurationUpdate',
  EmployeeCreate = 'employeeCreate',
  EmployeeUpdate = 'employeeUpdate',
  CustomerSkinAnalysisUpdate = 'customerSkinAnalysisUpdate',
  OrganisationUpdate = 'organisationUpdate',
  CreateRole = 'createRole',
  UpdateRole = 'updateRole',
  QuestionnaireCreate = 'questionnaireCreate',
  QuestionnaireUpdate = 'questionnaireUpdate',
  SalonCreate = 'salonCreate',
  SalonUpdate = 'salonUpdate',
  CreatePayment = 'createPayment',
  WhatsappCreditsPaymentCreate = 'whatsappCreditsPaymentCreate',
  AssistantCreditsPurchase = 'assistantCreditsPurchase',
  PaidCousePaymentCreate = 'paidCousePaymentCreate',
  CancelSubscription = 'cancelSubscription',
  UpdateSubscription = 'updateSubscription',
  CustomerConsentSend = 'customerConsentSend',
  CustomerDocumentSend = 'customerDocumentSend',
  CustomerDocumentDelete = 'customerDocumentDelete',
}

export interface EmployeeActivity {
  /** @format date-time */
  createdAt: string;
  data: any;
  type: EmployeeActivityType;
  userId?: string;
  id: string;
}

export interface EmployeeActivitySearchRequest {
  /** @format double */
  limit?: number;
  /** @format double */
  skip?: number;
  /** @format date-time */
  endDate?: string;
  /** @format date-time */
  startDate?: string;
  types?: EmployeeActivityType[];
  employeeIds?: string[];
}

export enum SalonPermissionType {
  ReadCustomers = 'readCustomers',
  ManageCustomers = 'manageCustomers',
  ReadEmployees = 'readEmployees',
  ManageEmployees = 'manageEmployees',
  ReadQuestionnaires = 'readQuestionnaires',
  ManageQuestionnaires = 'manageQuestionnaires',
  ReadAdvice = 'readAdvice',
  ManageAdvice = 'manageAdvice',
  ReadPlans = 'readPlans',
  ManagePlans = 'managePlans',
}

export type EffectivePermissions = Record<string, (SalonPermissionType | OrganisationPermissionType)[]>;

export interface EmployeeCreateRequest {
  email: string;
  displayName?: string;
  language: SupportedLanguage;
  salonsAccess: EmployeeSalonAccessPermissions[];
  organisationPermissions?: OrganisationPermissionType[];
  treatsCustomers?: boolean;
}

export interface EmployeeEditRequest {
  displayName?: string;
  language: SupportedLanguage;
  deleted: boolean;
  newPassword?: string;
  currentPassword?: string;
  salonsAccess: EmployeeSalonAccessPermissions[];
  organisationPermissions?: OrganisationPermissionType[];
  treatsCustomers?: boolean;
}

export interface SkinAnalysisIcon {
  id: string;
  iconName: string;
  groupName: string;
  customLabel?: string;
  /** @format double */
  x: number;
  /** @format double */
  y: number;
}

export interface SkinAnalysis {
  id: string;
  icons: SkinAnalysisIcon[];
  salonId: string;
  userId: string;
}

export interface SkinAnalysisUpdateRequest {
  icons: SkinAnalysisIcon[];
}

export interface GoogleEmployeeCalendar {
  employeeId: string;
  calendarId: string;
  calendarName?: string;
}

export interface GoogleCalendarConnection {
  id: string;
  salonId: string;
  connected: boolean;
  needsReauth?: boolean;
  calendarEmail?: string;
  calendarId?: string;
  calendarName?: string;
  calendarMode?: 'salon' | 'employee';
  employeeCalendars?: GoogleEmployeeCalendar[];
  /** @format date-time */
  connectedAt?: string;
}

export interface GoogleCalendarConnectRequest {
  code: string;
  redirectUri: string;
}

export interface GoogleCalendarEvent {
  id: string;
  summary: string;
  description?: string;
  startTime: string;
  endTime: string;
  attendees: string[];
}

export interface GoogleCalendarEventsResponse {
  connected: boolean;
  events: GoogleCalendarEvent[];
  calendarEmail?: string;
}

export interface GoogleCalendarListItem {
  id: string;
  name: string;
  primary: boolean;
}

export interface GoogleCalendarSelectRequest {
  calendarId: string;
  calendarName: string;
}

export interface GoogleCalendarConfigRequest {
  mode: 'salon' | 'employee';
  calendarId?: string;
  calendarName?: string;
  employeeCalendars?: GoogleEmployeeCalendar[];
}

export interface SalonizedSyncResult {
  connected: boolean;
  from: string;
  to: string;
  /** @format double */
  added: number;
  /** @format double */
  updated: number;
  /** @format double */
  removed: number;
  /** @format double */
  matchedCustomers: number;
  /** @format double */
  unmatchedCustomers: number;
  /** @format double */
  ambiguous: number;
  /** @format double */
  matchedEmployees: number;
}

export interface DailyQuestionnairesStats {
  /** @format double */
  organisations: number;
  /** @format double */
  salons: number;
  /** @format double */
  voorzorgSent: number;
  /** @format double */
  nazorgSent: number;
  /** @format double */
  matched: number;
  /** @format double */
  unmatched: number;
  /** @format double */
  errors: number;
}

export interface RunDailyQuestionnairesRequest {
  organisationId?: string;
  salonId?: string;
  date?: string;
  ignoreRunLock?: boolean;
}

export interface SalonizedSyncStats {
  /** @format double */
  organisations: number;
  /** @format double */
  salons: number;
  /** @format double */
  errors: number;
}

export enum MessageType {
  LoginRequest = 'loginRequest',
  NewQuestionnaire = 'newQuestionnaire',
  NewCustomQuestionnaire = 'newCustomQuestionnaire',
  NewEmployee = 'newEmployee',
  ResetPassword = 'resetPassword',
  SubscriptionUpdate = 'subscriptionUpdate',
  SubscriptionCancel = 'subscriptionCancel',
  RecurringPayment = 'recurringPayment',
  WhatsappCreditsPurchase = 'whatsappCreditsPurchase',
  AssistantCreditsPurchase = 'assistantCreditsPurchase',
  PaidCoursePurchase = 'paidCoursePurchase',
  NewCustomerConsentForm = 'newCustomerConsentForm',
  NewCustomerDocument = 'newCustomerDocument',
  NewOrganisation = 'newOrganisation',
  NewInternalOrganisation = 'newInternalOrganisation',
  NewAdviceNotification = 'newAdviceNotification',
  NewAffiliateUser = 'newAffiliateUser',
  ResetAffiliateUserPassword = 'resetAffiliateUserPassword',
  NewCommissionWithdrawalRequest = 'newCommissionWithdrawalRequest',
  NewPlanOffer = 'newPlanOffer',
  NewSneladvies = 'newSneladvies',
}

export interface EmailTemplate {
  filename?: string;
  /** Construct a type with a set of properties K of type T */
  sendgridTemplateId?: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  subject?: RecordSupportedLanguageString;
}

export interface MessageTemplate {
  emailTemplate: EmailTemplate;
  whatsAppTemplateName?: string;
  type: MessageType;
  name: string;
  id: string;
}

export interface CustomOrganisationField {
  displayName: string;
  propertyName: string;
}

export interface Organisation {
  id: string;
  companyNameToUse: string;
  slug: string;
  contactEmployeeId: string;
  mollieSubscriptionId?: string;
  mollieCustomerId: string;
  wefactClientId: string;
  customFields: CustomOrganisationField[];
  defaultCustomerMessagingType: OrganisationMessagingType;
  /** @format double */
  whatsappCredits: number;
  /** @format double */
  assistantsCredits: number;
  canModifyQuestionnaires: boolean;
  canModifyAdvice: boolean;
  canExportQuestionnaires: boolean;
  canUseTreatmentAnalysis?: boolean;
  canUseTrajecten?: boolean;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: string;
}

export interface GlobalAdminCreateOrganisationRequest {
  validTo: string;
  subscriptionOptionId: string;
  vatNumber?: string;
  city: string;
  postalCode: string;
  address: string;
  country: string;
  invoiceLanguage: SupportedLanguage;
  email: string;
  slug?: string;
  legalCompanyName?: string;
  companyNameToUse: string;
}

export interface GlobalAdminUpdateOrganisationRequest {
  canUseTrajecten?: boolean;
  canUseTreatmentAnalysis?: boolean;
  canExportQuestionnaires: boolean;
  canModifyAdvice: boolean;
  canModifyQuestionnaires: boolean;
  companyNameToUse: string;
  slug: string;
  organisationId: string;
}

export interface OrganisationInvoicingData {
  legalCompanyName: string;
  address: string;
  postalCode: string;
  city: string;
  country: string;
  vatNumber?: string;
  invoiceLanguage: SupportedLanguage;
}

export interface GlobalAdminUpdateOrganisationInvoicingDataRequest {
  legalCompanyName: string;
  organisationId: string;
}

export interface GlobalDiscountCode {
  id: string;
  code: string;
  name: string;
  /** @format date-time */
  validFrom: string;
  /** @format date-time */
  validTo?: string;
  discount: DiscountConfig;
}

export enum Algorithm {
  SHA1 = 'SHA-1',
  SHA256 = 'SHA-256',
  SHA512 = 'SHA-512',
}

export interface Challenge {
  algorithm: Algorithm;
  challenge: string;
  /** @format double */
  maxnumber?: number;
  salt: string;
  signature: string;
}

export interface PublicOrganisation {
  id: string;
  name: string;
  slug: string;
}

export interface OrganisationCustomerSettings {
  showReSenceAdvice: boolean;
  showAssistantsAdvice: boolean;
}

export interface OrganisationCreateRequest {
  legalCompanyName?: string;
  companyNameToUse?: string;
  slug?: string;
  vatNumber?: string;
  country: string;
  address: string;
  postalCode: string;
  city: string;
  invoiceLanguage: SupportedLanguage;
  email: string;
  password: string;
  challengePayload: string;
  confirmationString: string;
}

export interface OrganisationUpdateRequest {
  companyNameToUse: string;
  slug: string;
  contactEmployeeId: string;
  customFields: CustomOrganisationField[];
  defaultCustomerMessagingType: OrganisationMessagingType;
}

export interface OrganisationInvoicingDataUpdateRequest {
  legalCompanyName: string;
  vatNumber?: string;
  country: string;
  address: string;
  postalCode: string;
  city: string;
  invoiceLanguage: SupportedLanguage;
}

export interface Course {
  coverFocal?: string;
  coverImageUrl?: string;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  id: string;
}

export type PaidCourse = Course & {
  coverFocal?: string;
  coverImageUrl?: string;
  /** Construct a type with a set of properties K of type T */
  description: RecordSupportedLanguageString;
  purchased?: boolean;
  /** @format double */
  cost: number;
};

export type GlobalPaidCourse = PaidCourse & {
  discountCodesIds: string[];
};

export interface CourseCreateRequest {
  coverFocal?: string;
  coverImageUrl?: string;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
}

export type PaidCourseCreateRequest = CourseCreateRequest & {
  coverFocal?: string;
  coverImageUrl?: string;
  discountCodesIds: string[];
  /** Construct a type with a set of properties K of type T */
  description: RecordSupportedLanguageString;
  /** @format double */
  cost: number;
};

export type CourseUpdateRequest = CourseCreateRequest;

export type PaidCourseUpdateRequest = CourseUpdateRequest & {
  coverFocal?: string;
  coverImageUrl?: string;
  discountCodesIds: string[];
  /** @format double */
  cost: number;
  /** Construct a type with a set of properties K of type T */
  description: RecordSupportedLanguageString;
};

export enum ModuleSegmentType {
  Url = 'url',
  Text = 'text',
}

export interface ModuleSegment {
  /** Construct a type with a set of properties K of type T */
  text?: RecordSupportedLanguageString;
  url?: string;
  type: ModuleSegmentType;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  id: string;
}

export interface Module {
  segments: ModuleSegment[];
  courseId: string;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  id: string;
}

export interface ModuleCreateRequest {
  segments: ModuleSegment[];
  courseId: string;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
}

export interface ModuleUpdateRequest {
  segments: ModuleSegment[];
  courseId: string;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
}

export interface PaidCoursePaymentCreateResponse {
  checkoutUrl?: string;
  payment?: Payment;
}

export interface DiscountCode {
  code: string;
  name: string;
  discount: DiscountConfig;
}

export interface SalonRole {
  id: string;
  name: string;
  permissions: SalonPermissionType[];
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: string;
}

export interface SalonRoleCreateRequest {
  name: string;
  permissions: SalonPermissionType[];
}

export type SalonRoleUpdateRequest = SalonRoleCreateRequest & {
  deleted: boolean;
};

export enum PhotoSetLabel {
  Before = 'before',
  After = 'after',
  Progress = 'progress',
}

export enum PhotoAngle {
  LeftProfile = 'leftProfile',
  Left45 = 'left45',
  Front = 'front',
  Right45 = 'right45',
  RightProfile = 'rightProfile',
}

export interface PhotoTransform {
  /** @format double */
  centerX: number;
  /** @format double */
  centerY: number;
  /** @format double */
  scale: number;
  /** @format double */
  rotation: number;
}

export enum PhotoAlignment {
  Auto = 'auto',
  Manual = 'manual',
  None = 'none',
}

export interface PhotoSetPhoto {
  angle: PhotoAngle;
  originalUrl: string;
  alignedUrl: string;
  thumbUrl: string;
  /** @format double */
  originalWidth: number;
  /** @format double */
  originalHeight: number;
  transform: PhotoTransform;
  alignment: PhotoAlignment;
  takenAt: string;
}

export interface PhotoSet {
  id: string;
  customerId: string;
  takenAt: string;
  appointmentExternalId?: string;
  appointmentService?: string;
  label?: PhotoSetLabel;
  notes?: string;
  sharedWithCustomer: boolean;
  photos: PhotoSetPhoto[];
  createdAt: string;
}

export interface PhotoSetCreateRequest {
  customerId: string;
  appointmentExternalId?: string;
  takenAt?: string;
  label?: PhotoSetLabel;
}

export interface PhotoSetUpdateRequest {
  takenAt: string;
  appointmentExternalId?: string | null;
  label?: PhotoSetLabel | null;
  notes?: string | null;
  sharedWithCustomer: boolean;
}

export interface PhotoTransformRequest {
  transform: PhotoTransform;
  alignment: PhotoAlignment;
}

export enum PlanStatus {
  Active = 'active',
  Archived = 'archived',
}

export enum PlanDurationType {
  CalendarYear = 'calendarYear',
  CustomerStartDate = 'customerStartDate',
  Months = 'months',
  Treatments = 'treatments',
}

export interface Plan {
  id: string;
  name: string;
  questionnaireId?: string;
  /** @format double */
  year?: number;
  description?: string;
  status: PlanStatus;
  durationType: PlanDurationType;
  /** @format double */
  durationMonths?: number;
  /** @format double */
  treatmentCount?: number;
  renewable: boolean;
  renewedFromPlanId?: string;
  createdAt: string;
  updatedAt: string;
  /** @format double */
  memberCount?: number;
  /** @format double */
  acceptedCount?: number;
  /** @format double */
  completedCount?: number;
  /** @format double */
  expiringCount?: number;
  /** @format double */
  endedCount?: number;
}

export interface PlanCreateRequest {
  name: string;
  questionnaireId?: string;
  /** @format double */
  year?: number;
  description?: string;
  status?: PlanStatus;
  durationType?: PlanDurationType;
  /** @format double */
  durationMonths?: number;
  /** @format double */
  treatmentCount?: number;
  renewable?: boolean;
  renewedFromPlanId?: string;
}

export enum PlanOfferAskStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Declined = 'declined',
  NoResponse = 'no_response',
}

export enum PlanOfferChannel {
  Email = 'email',
  Whatsapp = 'whatsapp',
}

export enum PlanMembershipStatus {
  Active = 'active',
  NotRenewing = 'notRenewing',
  Stopped = 'stopped',
  Switched = 'switched',
  WillRenew = 'willRenew',
  Renewed = 'renewed',
}

export enum PlanSwitchTiming {
  Immediate = 'immediate',
  EndOfTerm = 'endOfTerm',
}

export interface PlanOfferOverview {
  id: string;
  customerId: string;
  customerName: string;
  askStatus: PlanOfferAskStatus;
  askChannel?: PlanOfferChannel;
  askSentAt?: string;
  respondedAt?: string;
  questionnaireSentAt?: string;
  questionnaireCompleted: boolean;
  completedAt?: string;
  startDate?: string;
  /** @format double */
  treatmentsDone?: number;
  /** @format double */
  plannedTreatmentCount?: number;
  treatmentPlanDescription?: string;
  linkedAppointmentExternalIds?: string[];
  membershipStatus?: PlanMembershipStatus;
  switchTiming?: PlanSwitchTiming;
  switchedToPlanId?: string;
  endedAt?: string;
  exitReason?: string;
  planningProposal?: string;
  planningProposalAt?: string;
  planningProposalNotes?: string;
}

export interface SetPlanOfferStatusRequest {
  status: PlanOfferAskStatus;
}

export interface SetPlanOfferMembershipRequest {
  status: PlanMembershipStatus;
  switchTiming?: PlanSwitchTiming | null;
  switchedToPlanId?: string | null;
  endedAt?: string | null;
  reason?: string | null;
}

export interface UpdatePlanOfferRequest {
  startDate?: string | null;
  /** @format double */
  treatmentsDone?: number | null;
  /** @format double */
  plannedTreatmentCount?: number | null;
  treatmentPlanDescription?: string | null;
  linkedAppointmentExternalIds?: string[] | null;
}

export interface GeneratePlanningProposalRequest {
  notes?: string | null;
}

export interface SendPlanAskResult {
  /** @format double */
  sent: number;
}

export interface AddPlanOffersResult {
  /** @format double */
  added: number;
  /** @format double */
  skipped: number;
}

export interface AddPlanOffersRequest {
  customerIds: string[];
}

export interface CustomerPlanOffer {
  plan: Plan;
  offer: PlanOfferOverview;
}

export interface PlanUpdateRequest {
  name: string;
  questionnaireId?: string;
  /** @format double */
  year?: number;
  description?: string;
  status: PlanStatus;
  durationType?: PlanDurationType;
  /** @format double */
  durationMonths?: number;
  /** @format double */
  treatmentCount?: number;
  renewable?: boolean;
}

export interface PlanOfferPublicView {
  planName: string;
  description?: string;
  salonName: string;
  alreadyResponded: boolean;
  choice?: 'yes' | 'no';
}

export interface ResolvePlanOfferRequest {
  slug: string;
  offerToken: string;
}

export interface RespondPlanOfferRequest {
  slug: string;
  offerToken: string;
  choice: 'yes' | 'no';
}

export interface QuestionSubmission {
  id: string;
  questionnaireSubmissionId: string;
  questionId: string;
  answer: string[];
}

export interface QuestionnaireSubmission {
  id: string;
  userId?: string;
  complete: boolean;
  /** @format date-time */
  startedAt: string;
  /** @format date-time */
  completedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  questionnaireId: string;
  questionSubmissions: QuestionSubmission[];
}

export interface QuestionnaireSubmissionRequest {
  userId: string;
  questionnaireId: string;
  notificationToSend?: QuestionnaireSubmissionNotification;
  notifyOnComplete?: boolean;
  fromPublicLink?: boolean;
}

export interface SalonSubmissionOverview {
  id: string;
  userId?: string;
  complete: boolean;
  /** @format date-time */
  startedAt: string;
  /** @format date-time */
  completedAt?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  questionnaireId: string;
  questionSubmissions: QuestionSubmission[];
  customerName: string;
}

export enum QuestionnaireType {
  CustomerQuestionnaire = 'customerQuestionnaire',
  EmployeeQuestionnaire = 'employeeQuestionnaire',
}

export interface QuestionRenderLogic {
  value: string;
  questionId: string;
}

export interface QuestionRenderLogicConfiguration {
  display: QuestionRenderLogic[];
}

export interface QuestionConfigurationBase {
  renderLogic?: QuestionRenderLogicConfiguration;
  isRequired?: boolean;
}

export enum QuestionTypeString {
  String = 'string',
}

export type StringQuestionConfiguration = QuestionConfigurationBase & {
  type: QuestionTypeString;
};

export enum QuestionTypeOption {
  Option = 'option',
}

export interface QuestionOption {
  id: string;
  /** Construct a type with a set of properties K of type T */
  customerTitle: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  employeeTitle: RecordSupportedLanguageString;
  isHidden: boolean;
}

export type OptionsQuestionConfiguration = QuestionConfigurationBase & {
  /** @format double */
  order: number;
  allowMultipleValues?: boolean;
  allowCustomValue?: boolean;
  options: QuestionOption[];
  type: QuestionTypeOption;
};

export enum QuestionTypeDate {
  Date = 'date',
}

export type DateQuestionConfiguration = QuestionConfigurationBase & {
  type: QuestionTypeDate;
};

export enum QuestionTypeImage {
  Image = 'image',
}

export interface ImageQuestionOption {
  id: string;
  image: string;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  customerTitle: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  employeeTitle: RecordSupportedLanguageString;
}

export type ImageQuestionConfiguration = QuestionConfigurationBase & {
  allowMultipleValues?: boolean;
  options: ImageQuestionOption[];
  type: QuestionTypeImage;
};

export enum QuestionTypeRating {
  Rating = 'rating',
}

export type RatingQuestionConfiguration = QuestionConfigurationBase & {
  type: QuestionTypeRating;
};

export enum QuestionTypeBoolean {
  Boolean = 'boolean',
}

export type BooleanQuestionConfiguration = QuestionConfigurationBase & {
  type: QuestionTypeBoolean;
};

export enum QuestionTypeInformation {
  Information = 'information',
}

export type InformationQuestionConfiguration = QuestionConfigurationBase & {
  video?: string;
  image?: string;
  /** Construct a type with a set of properties K of type T */
  body: RecordSupportedLanguageString;
  type: QuestionTypeInformation;
};

export type QuestionConfiguration =
  | StringQuestionConfiguration
  | OptionsQuestionConfiguration
  | DateQuestionConfiguration
  | ImageQuestionConfiguration
  | RatingQuestionConfiguration
  | BooleanQuestionConfiguration
  | InformationQuestionConfiguration;

export interface Question {
  id: string;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** @format double */
  sortOrder: number;
  configuration: QuestionConfiguration;
  questionnaireId: string;
}

export interface Questionnaire {
  id: string;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  type: QuestionnaireType;
  salonId: string;
  disabled: boolean;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  questions: Question[];
  messageTemplateId?: string;
  /** @format double */
  sortOrder: number;
  publicLinkEnabled?: boolean;
  publicToken?: string;
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: string;
  isBuiltIn: boolean;
  originalId: string;
}

export interface SyncQuestionnairesToOrganisationsRequest {
  organisationsIds: string[];
  questionnaireId: string;
}

export interface PublicQuestionnaireResolveResponse {
  organisationId: string;
  salonId: string;
  questionnaireId: string;
  /** Construct a type with a set of properties K of type T */
  questionnaireName: RecordSupportedLanguageString;
  language: SupportedLanguage;
}

export interface PublicQuestionnaireResolveRequest {
  slug: string;
  publicToken: string;
}

export interface PublicQuestionnaireRequestCodeRequest {
  slug: string;
  publicToken: string;
  email: string;
  name: string;
  challengePayload: string;
}

export interface PublicQuestionnaireVerifyResponse {
  language: SupportedLanguage;
  token: string;
  organisationId: string;
  type: UserTypeCustomer;
  email: string;
  id: string;
  salonId: string;
  questionnaireSubmissionId: string;
}

export interface PublicQuestionnaireVerifyRequest {
  slug: string;
  publicToken: string;
  email: string;
  name: string;
  confirmationCode: string;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickQuestionnaireExcludeKeysIdOrQuestionsOrSalonIdOrDeletedAtOrDeletedByOrOriginalIdOrDisabled {
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description?: RecordSupportedLanguageString;
  type: QuestionnaireType;
  messageTemplateId?: string;
  /** @format double */
  sortOrder: number;
  publicLinkEnabled?: boolean;
  publicToken?: string;
  isBuiltIn: boolean;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitQuestionnaireIdOrQuestionsOrSalonIdOrDeletedAtOrDeletedByOrOriginalIdOrDisabled =
  PickQuestionnaireExcludeKeysIdOrQuestionsOrSalonIdOrDeletedAtOrDeletedByOrOriginalIdOrDisabled;

/** From T, pick a set of properties whose keys are in the union K */
export interface PickQuestionExcludeKeysQuestionnaireIdOrConfiguration {
  id: string;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** @format double */
  sortOrder: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitQuestionQuestionnaireIdOrConfiguration = PickQuestionExcludeKeysQuestionnaireIdOrConfiguration;

export enum QuestionType {
  String = 'string',
  Option = 'option',
  Number = 'number',
  Boolean = 'boolean',
  Date = 'date',
  Rating = 'rating',
  Image = 'image',
  Information = 'information',
}

export interface QuestionOptionCreateType {
  /** @format double */
  order: number;
  isHidden: boolean;
  /** Construct a type with a set of properties K of type T */
  employeeTitle: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  customerTitle: RecordSupportedLanguageString;
  image?: string;
  id: string;
}

export interface QuestionConfigurationCreateType {
  video?: string;
  image?: string;
  /** Construct a type with a set of properties K of type T */
  body?: RecordSupportedLanguageString;
  options?: QuestionOptionCreateType[];
  type: QuestionType;
  renderLogic?: QuestionRenderLogicConfiguration;
  isHidden: boolean;
  isRequired: boolean;
  allowMultipleValues?: boolean;
  allowCustomValue?: boolean;
}

export type QuestionCreateType = OmitQuestionQuestionnaireIdOrConfiguration & {
  configuration: QuestionConfigurationCreateType;
};

export type QuestionnaireCreateRequest = OmitQuestionnaireIdOrQuestionsOrSalonIdOrDeletedAtOrDeletedByOrOriginalIdOrDisabled & {
  questions: QuestionCreateType[];
};

/** From T, pick a set of properties whose keys are in the union K */
export interface PickQuestionExcludeKeysIdOrQuestionnaireIdOrConfiguration {
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** @format double */
  sortOrder: number;
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitQuestionIdOrQuestionnaireIdOrConfiguration = PickQuestionExcludeKeysIdOrQuestionnaireIdOrConfiguration;

export interface QuestionOptionUpdateType {
  /** @format double */
  order: number;
  isHidden: boolean;
  /** Construct a type with a set of properties K of type T */
  employeeTitle: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  customerTitle: RecordSupportedLanguageString;
  image?: string;
  id: string;
}

export interface QuestionConfigurationUpdateType {
  video?: string;
  image?: string;
  /** Construct a type with a set of properties K of type T */
  body?: RecordSupportedLanguageString;
  options?: QuestionOptionUpdateType[];
  type: QuestionType;
  renderLogic?: QuestionRenderLogicConfiguration;
  isHidden: boolean;
  isRequired: boolean;
  allowMultipleValues?: boolean;
  allowCustomValue?: boolean;
}

export type QuestionUpdateType = OmitQuestionIdOrQuestionnaireIdOrConfiguration & {
  configuration: QuestionConfigurationUpdateType;
  id: string;
};

export type QuestionnaireUpdateRequest = OmitQuestionnaireIdOrQuestionsOrSalonIdOrDeletedAtOrDeletedByOrOriginalIdOrDisabled & {
  deleted: boolean;
  questions: (QuestionUpdateType | QuestionCreateType)[];
};

/** Object containing file metadata and access information. */
export interface ExpressMulterFile {
  /** Name of the form field associated with this file. */
  fieldname: string;
  /** Name of the file on the uploader's computer. */
  originalname: string;
  /**
   * Value of the `Content-Transfer-Encoding` header for this file.
   * @deprecated
   */
  encoding: string;
  /** Value of the `Content-Type` header for this file. */
  mimetype: string;
  /**
   * Size of the file in bytes.
   * @format double
   */
  size: number;
  /**
   * A readable stream of this file. Only available to the `_handleFile`
   * callback for custom `StorageEngine`s.
   * @format byte
   */
  stream: string;
  /** `DiskStorage` only: Directory to which this file has been uploaded. */
  destination: string;
  /** `DiskStorage` only: Name of this file within `destination`. */
  filename: string;
  /** `DiskStorage` only: Full path to the uploaded file. */
  path: string;
  /**
   * `MemoryStorage` only: A Buffer containing the entire file.
   * @format byte
   */
  buffer: string;
}

export interface SaleImportResult {
  importId: string;
  fileName: string;
  /** @format double */
  rowCount: number;
  /** @format double */
  importedCount: number;
  /** @format double */
  duplicateCount: number;
  /** @format double */
  matchedCount: number;
  /** @format double */
  unmatchedCount: number;
  /** @format double */
  ambiguousCount: number;
}

export interface RawSaleRow {
  order_id?: string;
  date?: string;
  employee?: string;
  customer_id?: string;
  customer_name?: string;
  type?: string;
  product_id?: string;
  description?: string;
  category?: string;
  quantity?: string;
  price?: string;
  vat_percentage?: string;
  total?: string;
  vat_amount?: string;
  discount?: string;
  customer_birth_date?: string;
}

export interface SaleImportRequest {
  fileName: string;
  rows: RawSaleRow[];
}

export interface SaleImportOverview {
  id: string;
  fileName: string;
  importedBy: string;
  createdAt: string;
  /** @format double */
  rowCount: number;
  /** @format double */
  importedCount: number;
  /** @format double */
  duplicateCount: number;
  /** @format double */
  matchedCount: number;
  /** @format double */
  unmatchedCount: number;
  /** @format double */
  ambiguousCount: number;
}

export interface CustomerSale {
  id: string;
  orderId: string;
  orderDate: string;
  employee?: string;
  type: 'service' | 'product';
  description: string;
  category?: string;
  /** @format double */
  quantity: number;
  /** @format double */
  price: number;
  /** @format double */
  vatPercentage: number;
  /** @format double */
  total: number;
  /** @format double */
  vatAmount: number;
  /** @format double */
  discount: number;
}

export interface SalonizedStatus {
  connected: boolean;
  email?: string;
  url?: string;
  /** @format double */
  companyId?: number;
  /** @format double */
  locationId?: number;
  lastError?: string;
  /** @format double */
  appointmentCount: number;
}

export interface SalonizedConnectRequest {
  email: string;
  password: string;
  url?: string;
}

export interface SalonizedDeleteResult {
  /** @format double */
  deleted: number;
}

export interface SalonizedStoredAppointment {
  id: string;
  externalId: string;
  sourceUrl?: string;
  hasSpokenAdvice: boolean;
  start: string;
  end: string;
  service?: string;
  employeeName?: string;
  matchedEmployeeId?: string;
  customerName?: string;
  matchedCustomerId?: string;
  customerMatchStatus: 'matched' | 'unmatched' | 'ambiguous' | 'no-name';
  voorzorgSentAt?: string;
  nazorgSentAt?: string;
  voorzorgSubmissionId?: string;
  nazorgSubmissionId?: string;
}

export interface SalonizedTreatmentCount {
  employeeId: string;
  /** @format double */
  count: number;
}

export interface SalonizedCustomerAppointment {
  externalId: string;
  start: string;
  end: string;
  service?: string;
  employeeName?: string;
}

export interface SalonizedSendCareRequest {
  type: 'voorzorg' | 'nazorg';
}

export interface SalonizedEmployee {
  id: string;
  name: string;
}

export interface SalonizedAppointment {
  employeeId: string;
  employeeName: string;
  start: string;
  end: string;
  customerName?: string;
  service: string;
  notes?: string;
}

export interface SalonizedAgendaWeek {
  connected: boolean;
  from: string;
  to: string;
  employees: SalonizedEmployee[];
  appointments: SalonizedAppointment[];
}

export enum SalonSoftware {
  Salonized = 'salonized',
  GoogleCalendar = 'googleCalendar',
  GoBooky = 'goBooky',
}

export interface Salon {
  id: string;
  name: string;
  description?: string;
  salonSoftware?: SalonSoftware;
  /** @format double */
  customersCount: number;
  /** @format double */
  employeesCount: number;
  enabledAssistantsIds: string[];
  /** @format date-time */
  deletedAt?: string;
  deletedBy?: string;
}

export interface SalonCreateRequest {
  name: string;
  description?: string;
  salonSoftware?: SalonSoftware;
}

export interface SalonUpdateRequest {
  name: string;
  description?: string;
  salonSoftware?: SalonSoftware;
  deleted: boolean;
}

export interface SneladviesBlock {
  id: string;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  text: RecordSupportedLanguageString;
  /** @format double */
  order?: number;
  createdAt: string;
  updatedAt: string;
}

export interface SneladviesBlockCreateRequest {
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  text: RecordSupportedLanguageString;
}

export interface SneladviesTranslateResult {
  name: string;
  text: string;
}

export interface SneladviesTranslateRequest {
  name: string;
  text: string;
}

export interface SetSneladviesSelectionRequest {
  blockIds: string[];
  note?: string | null;
}

export interface SneladviesBlockUpdateRequest {
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  text: RecordSupportedLanguageString;
}

export interface SpokenAdviceClassification {
  key: string;
  label: string;
}

export interface SpokenAdviceFile {
  fileUrl: string;
  fileName: string;
  mimeType?: string;
}

export interface SpokenAdviceConfig {
  instruction: string;
  customerClassifications: SpokenAdviceClassification[];
  employeeClassifications: SpokenAdviceClassification[];
  files: SpokenAdviceFile[];
}

export interface GenerateSpokenAdviceResult {
  success: boolean;
  response: string;
  transcript: string;
  adviceId?: string;
}

export interface SpokenAdvice {
  id: string;
  userId: string;
  salonId: string;
  advice: string;
  transcript?: string;
  salonizedAppointmentExternalId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SpokenAdviceConfigPublic {
  enabled: boolean;
  customerClassifications: SpokenAdviceClassification[];
  employeeClassifications: SpokenAdviceClassification[];
}

export interface SpokenEmployeeClassification {
  employeeId: string;
  classificationKey: string;
}

export interface SetSpokenClassificationsRequest {
  userId: string;
  customerClassification?: string;
  employeeClassifications: SpokenEmployeeClassification[];
}

export interface UpdateSpokenAdviceRequest {
  advice: string;
}

export interface StaffMessage {
  id: string;
  type: string;
  senderName?: string;
  customerName?: string;
  questionnaireName?: string;
  relatedCustomerId?: string;
  relatedSubmissionId?: string;
  read: boolean;
  createdAt: string;
}

export enum SubscriptionOptionFeature {
  Customer = 'customer',
  Employee = 'employee',
  Salon = 'salon',
  Wishes = 'wishes',
  Skin = 'skin',
  Vitality = 'vitality',
  Advice = 'advice',
  Fingerprint = 'fingerprint',
  Trajecten = 'trajecten',
}

export interface FeatureExtra {
  id: string;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** @format double */
  cost: number;
  disabled: boolean;
  features: {
    /** @format double */
    value: number;
    feature: SubscriptionOptionFeature;
  }[];
}

export interface SubscriptionOption {
  groups: string[];
  discountCodesIds?: string[];
  applyAffiliateDiscountCode?: boolean;
  isHidden?: boolean;
  isTrial?: boolean;
  isHighlighted: boolean;
  /** @format double */
  order: number;
  featureExtras: FeatureExtra[];
  duration: {
    /** @format double */
    years: number;
    /** @format double */
    months: number;
    /** @format double */
    days: number;
  };
  questionnaireIds: string[];
  assistantIds: string[];
  features: {
    /** @format double */
    value: number;
    feature: SubscriptionOptionFeature;
  }[];
  /** Construct a type with a set of properties K of type T */
  description2: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description: RecordSupportedLanguageString;
  /** @format double */
  cost: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  id: string;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickSubscriptionOptionExcludeKeysIdOrCost {
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  /** Construct a type with a set of properties K of type T */
  description: RecordSupportedLanguageString;
  /** @format double */
  order: number;
  /** Construct a type with a set of properties K of type T */
  description2: RecordSupportedLanguageString;
  features: {
    /** @format double */
    value: number;
    feature: SubscriptionOptionFeature;
  }[];
  assistantIds: string[];
  questionnaireIds: string[];
  duration: {
    /** @format double */
    years: number;
    /** @format double */
    months: number;
    /** @format double */
    days: number;
  };
  featureExtras: FeatureExtra[];
  isHighlighted: boolean;
  isTrial?: boolean;
  isHidden?: boolean;
  applyAffiliateDiscountCode?: boolean;
  discountCodesIds?: string[];
  groups: string[];
}

/** Construct a type with the properties of T except for those in type K. */
export type OmitSubscriptionOptionIdOrCost = PickSubscriptionOptionExcludeKeysIdOrCost;

export type SubscriptionOptionUpdateRequest = OmitSubscriptionOptionIdOrCost;

export type SubscriptionOptionCreateRequest = {
  /** @format double */
  cost: number;
} & SubscriptionOptionUpdateRequest;

export enum SubscriptionStatus {
  Pending = 'pending',
  Active = 'active',
  Canceled = 'canceled',
  Suspended = 'suspended',
  Completed = 'completed',
}

export interface MollieCustomerSubscription {
  discountCode: string;
  name: string;
  organisationName?: string;
  status: SubscriptionStatus;
  nextPaymentDate?: string;
  interval: string;
  value: string;
  customerId: string;
  currency: string;
  id: string;
}

export type IRecordOfAny = Record<string, any>;

export interface Subscription {
  /** @format double */
  employeesCount: number;
  /** @format double */
  salonsCount: number;
  /** @format double */
  customersCount: number;
  payments: Payment[];
  startedBy?: string;
  /** @format date-time */
  validTo?: string;
  /** @format date-time */
  startedAt?: string;
  subscriptionOptionDuration?: {
    /** @format double */
    days: number;
    /** @format double */
    months: number;
    /** @format double */
    years: number;
  };
  /** Construct a type with a set of properties K of type T */
  subscriptionOptionName?: RecordSupportedLanguageString;
  questionnaireIds: string[];
  assistantIds: string[];
  effectiveLimits: {
    /** @format double */
    trajecten: number;
    /** @format double */
    vitality: number;
    /** @format double */
    skin: number;
    /** @format double */
    fingerprint: number;
    /** @format double */
    advice: number;
    /** @format double */
    wishes: number;
    /** @format double */
    salon: number;
    /** @format double */
    employee: number;
    /** @format double */
    customer: number;
  };
  subscriptionOptionExtrasIds: string[];
  subscriptionOptionId?: string;
  id: string;
}

export interface SubscriptionNextPayment {
  nextPaymentOptionExtrasIds: string[];
  nextPaymentOptionId: string;
  nextPaymentAmount: string;
  /** @format date-time */
  nextPaymentDate: string;
}

export interface SubscriptionOptionPaymentAndSubscriptionCreateResponse {
  checkoutUrl: string;
  payment: Payment;
}

export interface SubscriptionOptionPaymentAndSubscriptionCreateRequest {
  skipEmail?: boolean;
  discountCode?: string;
  autoExtend: boolean;
  redirectUrl?: string;
  subscriptionOptionExtrasIds: string[];
  subscriptionOptionId: string;
}

export interface TreatmentAnalysisResult {
  analysis: string;
  traject?: string;
}

export interface TreatmentAnalysisRequest {
  customerId: string;
  from: string;
  to: string;
}

export interface TreatmentAnalysisBatchItem {
  customerId: string;
  traject?: string;
  success: boolean;
  error?: string;
}

export interface TreatmentAnalysisBatchResult {
  results: TreatmentAnalysisBatchItem[];
}

export interface TreatmentAnalysisBatchRequest {
  customerIds: string[];
  from: string;
  to: string;
}

export interface UploadedItem {
  url: string;
}

/** Construct a type with a set of properties K of type T */
export type RecordStringStringArray = object;

export interface ImagesCategoriesTree {
  Advice: string[];
  SkinGroups: string[];
  /** Construct a type with a set of properties K of type T */
  SkinDragAndDrop: RecordStringStringArray;
  /** Construct a type with a set of properties K of type T */
  Reports: RecordStringStringArray;
  /** Construct a type with a set of properties K of type T */
  Wishes: RecordStringStringArray;
  /** Construct a type with a set of properties K of type T */
  Vitality: RecordStringStringArray;
  /** Construct a type with a set of properties K of type T */
  Skin: RecordStringStringArray;
}

export interface WhatsappCreditsPaymentCreateResponse {
  checkoutUrl: string;
  payment: Payment;
}

export interface WhatsappCreditsPaymentCreateRequest {
  whatsappCreditsOptionId: string;
}

export interface WhatsappCreditsOption {
  /** @format double */
  count: number;
  /** @format double */
  cost: number;
  /** Construct a type with a set of properties K of type T */
  name: RecordSupportedLanguageString;
  id: string;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (securityData: SecurityDataType | null) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '/' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title beauty-app-api
 * @version 1.0.0
 * @license ISC
 * @baseUrl /
 * @contact
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  activeCampaign = {
    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name GetConnectionStatus
     * @request GET:/organisations/{organisationId}/salons/{salonId}/active-campaign/status
     * @secure
     */
    getConnectionStatus: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<ActiveCampaignStatus, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name Connect
     * @request POST:/organisations/{organisationId}/salons/{salonId}/active-campaign/connect
     * @secure
     */
    connect: (organisationId: string, salonId: string, data: ActiveCampaignConnectRequest, params: RequestParams = {}) =>
      this.request<ActiveCampaignStatus, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/connect`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name Disconnect
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/active-campaign/disconnect
     * @secure
     */
    disconnect: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/disconnect`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name GetLists
     * @request GET:/organisations/{organisationId}/salons/{salonId}/active-campaign/lists
     * @secure
     */
    getLists: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<ActiveCampaignList[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/lists`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name ListConfigs
     * @request GET:/organisations/{organisationId}/salons/{salonId}/active-campaign/configs
     * @secure
     */
    listConfigs: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<ActiveCampaignConfig[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/configs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name CreateConfig
     * @request POST:/organisations/{organisationId}/salons/{salonId}/active-campaign/configs
     * @secure
     */
    createConfig: (organisationId: string, salonId: string, data: ActiveCampaignConfigRequest, params: RequestParams = {}) =>
      this.request<ActiveCampaignConfig, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/configs`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name UpdateConfig
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/active-campaign/configs/{configId}
     * @secure
     */
    updateConfig: (
      organisationId: string,
      salonId: string,
      configId: string,
      data: ActiveCampaignConfigRequest,
      params: RequestParams = {},
    ) =>
      this.request<ActiveCampaignConfig, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/configs/${configId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ActiveCampaign
     * @name DeleteConfig
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/active-campaign/configs/{configId}
     * @secure
     */
    deleteConfig: (organisationId: string, salonId: string, configId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/active-campaign/configs/${configId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  advices = {
    /**
     * No description
     *
     * @tags Advices
     * @name GetAdvices
     * @request GET:/organisations/{organisationId}/salons/{salonId}/advices
     * @secure
     */
    getAdvices: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<Advice[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name CreateAdvice
     * @request POST:/organisations/{organisationId}/salons/{salonId}/advices
     * @secure
     */
    createAdvice: (organisationId: string, salonId: string, data: AdviceCreateRequest, params: RequestParams = {}) =>
      this.request<Advice, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name GetAdviceGroups
     * @request GET:/organisations/{organisationId}/salons/{salonId}/advices/advice-groups
     * @secure
     */
    getAdviceGroups: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<AdviceGroup[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-groups`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name CreateAdviceGroup
     * @request POST:/organisations/{organisationId}/salons/{salonId}/advices/advice-groups
     * @secure
     */
    createAdviceGroup: (organisationId: string, salonId: string, data: AdviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<AdviceGroup, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-groups`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name GetAdviceConditions
     * @request GET:/organisations/{organisationId}/salons/{salonId}/advices/advice-conditions
     * @secure
     */
    getAdviceConditions: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<AdviceCondition[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-conditions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name CreateAdviceCondition
     * @request POST:/organisations/{organisationId}/salons/{salonId}/advices/advice-conditions
     * @secure
     */
    createAdviceCondition: (
      organisationId: string,
      salonId: string,
      data: AdviceConditionCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdviceCondition, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-conditions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name ReorderAdvices
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/advices/order
     * @secure
     */
    reorderAdvices: (organisationId: string, salonId: string, data: ReorderRequest, params: RequestParams = {}) =>
      this.request<Advice[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name UpdateAdvice
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/advices/{adviceId}
     * @secure
     */
    updateAdvice: (
      organisationId: string,
      salonId: string,
      adviceId: string,
      data: AdviceUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<Advice, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/${adviceId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name UpdateAdviceGroup
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/advices/advice-groups/{adviceGroupId}
     * @secure
     */
    updateAdviceGroup: (
      organisationId: string,
      salonId: string,
      adviceGroupId: string,
      data: AdviceGroupUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdviceGroup, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-groups/${adviceGroupId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name DeleteAdviceGroup
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/advices/advice-groups/{adviceGroupId}
     * @secure
     */
    deleteAdviceGroup: (organisationId: string, salonId: string, adviceGroupId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-groups/${adviceGroupId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name UpdateAdviceCondition
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/advices/advice-conditions/{adviceConditionId}
     * @secure
     */
    updateAdviceCondition: (
      organisationId: string,
      salonId: string,
      adviceConditionId: string,
      data: AdviceConditionUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdviceCondition, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-conditions/${adviceConditionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Advices
     * @name DeleteAdviceCondition
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/advices/advice-conditions/{adviceConditionId}
     * @secure
     */
    deleteAdviceCondition: (organisationId: string, salonId: string, adviceConditionId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/advices/advice-conditions/${adviceConditionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  affiliatesController = {
    /**
     * No description
     *
     * @tags AffiliatesController
     * @name InviteAffiliateUser
     * @request POST:/affiliates
     * @secure
     */
    inviteAffiliateUser: (data: AffiliateInviteRequest, params: RequestParams = {}) =>
      this.request<AffiliateUser, any>({
        path: `/affiliates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name UpdateAffiliateUser
     * @request PUT:/affiliates
     * @secure
     */
    updateAffiliateUser: (data: AffiliateUserUpdateRequest, params: RequestParams = {}) =>
      this.request<AffiliateUser, any>({
        path: `/affiliates`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name GetAffiliateUsers
     * @request GET:/affiliates
     * @secure
     */
    getAffiliateUsers: (params: RequestParams = {}) =>
      this.request<AffiliateUser[], any>({
        path: `/affiliates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name ResetAffiliateUserPassword
     * @request PUT:/affiliates/password-reset
     */
    resetAffiliateUserPassword: (data: AffiliateUserPasswordResetRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/affiliates/password-reset`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name GetCurrentAffiliateUserData
     * @request GET:/affiliates/me
     * @secure
     */
    getCurrentAffiliateUserData: (params: RequestParams = {}) =>
      this.request<AffiliateUser, any>({
        path: `/affiliates/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name UpdateCurrentAffiliateUserData
     * @request PUT:/affiliates/me
     * @secure
     */
    updateCurrentAffiliateUserData: (data: CurrentAffiliateUserUpdateRequest, params: RequestParams = {}) =>
      this.request<AffiliateUser, any>({
        path: `/affiliates/me`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name RequestAffiliateUserPasswordReset
     * @request POST:/affiliates/request-password-reset
     */
    requestAffiliateUserPasswordReset: (
      data: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/affiliates/request-password-reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name AffiliateUserLogin
     * @request POST:/affiliates/login
     */
    affiliateUserLogin: (
      data: {
        password: string;
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AffiliateUserJwtClaims, any>({
        path: `/affiliates/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name CreateWithdrawal
     * @request POST:/affiliates/me/withdrawal
     * @secure
     */
    createWithdrawal: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/affiliates/me/withdrawal`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AffiliatesController
     * @name UpdateWithdrawal
     * @request POST:/affiliates/{userId}/withdrawals/{withdrawalId}
     * @secure
     */
    updateWithdrawal: (
      userId: string,
      withdrawalId: string,
      data: {
        paidOut: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/affiliates/${userId}/withdrawals/${withdrawalId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  globalAiSkills = {
    /**
     * No description
     *
     * @tags GlobalAiSkills
     * @name GetSkills
     * @request GET:/global/ai-skills
     * @secure
     */
    getSkills: (params: RequestParams = {}) =>
      this.request<AiSkill[], any>({
        path: `/global/ai-skills`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalAiSkills
     * @name CreateSkill
     * @request POST:/global/ai-skills
     * @secure
     */
    createSkill: (data: AiSkillCreateRequest, params: RequestParams = {}) =>
      this.request<AiSkill, any>({
        path: `/global/ai-skills`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalAiSkills
     * @name UpdateSkill
     * @request PUT:/global/ai-skills/{skillId}
     * @secure
     */
    updateSkill: (skillId: string, data: AiSkillUpdateRequest, params: RequestParams = {}) =>
      this.request<AiSkill, any>({
        path: `/global/ai-skills/${skillId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalAiSkills
     * @name DeleteSkill
     * @request DELETE:/global/ai-skills/{skillId}
     * @secure
     */
    deleteSkill: (skillId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/ai-skills/${skillId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  appointments = {
    /**
     * No description
     *
     * @tags Appointments
     * @name GetAppointments
     * @request GET:/organisations/{organisationId}/salons/{salonId}/appointments
     * @secure
     */
    getAppointments: (
      organisationId: string,
      salonId: string,
      query?: {
        /** @format double */
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppointmentOverview[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/appointments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  assistantCredits = {
    /**
     * No description
     *
     * @tags Assistant credits
     * @name CreateAssistantCreditsPayment
     * @request POST:/organisations/{organisationId}/assistant-credits/credit-payment
     * @secure
     */
    createAssistantCreditsPayment: (
      organisationId: string,
      data: AssistantCreditsPaymentCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AssistantCreditsPaymentCreateResponse, any>({
        path: `/organisations/${organisationId}/assistant-credits/credit-payment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistant credits
     * @name GetAssistantCreditsOptions
     * @request GET:/organisations/{organisationId}/assistant-credits/options
     * @secure
     */
    getAssistantCreditsOptions: (organisationId: string, params: RequestParams = {}) =>
      this.request<AssistantCreditsOption[], any>({
        path: `/organisations/${organisationId}/assistant-credits/options`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  assistants = {
    /**
     * No description
     *
     * @tags Assistants
     * @name GetSalonAssistants
     * @request GET:/organisations/{organisationId}/salons/{salonId}/assistants
     * @secure
     */
    getSalonAssistants: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<Assistant[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/assistants`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name GenerateAssistantAdvice
     * @request POST:/organisations/{organisationId}/salons/{salonId}/assistant-advice
     * @secure
     */
    generateAssistantAdvice: (
      organisationId: string,
      salonId: string,
      data: GenerateAssistantAdviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          response: string;
          success: boolean;
        },
        any
      >({
        path: `/organisations/${organisationId}/salons/${salonId}/assistant-advice`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name GetAssistantsAdvices
     * @request GET:/organisations/{organisationId}/salons/{salonId}/assistant-advice
     * @secure
     */
    getAssistantsAdvices: (
      organisationId: string,
      salonId: string,
      query: {
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssistantAdvice[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/assistant-advice`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name DeleteAssistantAdvice
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/assistant-advice/{adviceId}
     * @secure
     */
    deleteAssistantAdvice: (organisationId: string, salonId: string, adviceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/assistant-advice/${adviceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name UpdateAssistantAdvice
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/assistant-advice/{adviceId}
     * @secure
     */
    updateAssistantAdvice: (
      organisationId: string,
      salonId: string,
      adviceId: string,
      data: UpdateAssistantAdviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<AssistantAdvice, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/assistant-advice/${adviceId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name UpdateEnabledSalonsAssistants
     * @request PUT:/organisations/{organisationId}/salons-assistants
     * @secure
     */
    updateEnabledSalonsAssistants: (organisationId: string, data: UpdateSelectedAssistantsRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons-assistants`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Assistants
     * @name GetAvailableAssistants
     * @request GET:/organisations/{organisationId}/assistants
     * @secure
     */
    getAvailableAssistants: (organisationId: string, params: RequestParams = {}) =>
      this.request<Assistant[], any>({
        path: `/organisations/${organisationId}/assistants`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  globalAssistants = {
    /**
     * No description
     *
     * @tags GlobalAssistants
     * @name CreateAssistant
     * @request POST:/global/assistants
     * @secure
     */
    createAssistant: (data: AssistantCreateRequest, params: RequestParams = {}) =>
      this.request<GlobalAssistant, any>({
        path: `/global/assistants`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalAssistants
     * @name UpdateAssistant
     * @request PUT:/global/assistants/{assistantId}
     * @secure
     */
    updateAssistant: (assistantId: string, data: AssistantUpdateRequest, params: RequestParams = {}) =>
      this.request<GlobalAssistant, any>({
        path: `/global/assistants/${assistantId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalAssistants
     * @name DeleteAssistant
     * @request DELETE:/global/assistants/{assistantId}
     * @secure
     */
    deleteAssistant: (assistantId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/assistants/${assistantId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalAssistants
     * @name GetGlobalAssistants
     * @request GET:/global/assistants/global
     * @secure
     */
    getGlobalAssistants: (params: RequestParams = {}) =>
      this.request<GlobalAssistant[], any>({
        path: `/global/assistants/global`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  authentication = {
    /**
     * No description
     *
     * @tags Authentication
     * @name RequestCustomerLoginCode
     * @request POST:/organisations/{organisationId}/authentication/customer-login-request
     */
    requestCustomerLoginCode: (
      organisationId: string,
      data: {
        method: 'email' | 'whatsapp';
        slug: string;
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/authentication/customer-login-request`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name VerifyCustomerLoginCode
     * @request POST:/organisations/{organisationId}/authentication/customer-login-request/verify
     */
    verifyCustomerLoginCode: (
      organisationId: string,
      data: {
        slug: string;
        confirmationCode: string;
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerJwtClaims, any>({
        path: `/organisations/${organisationId}/authentication/customer-login-request/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name EmployeeLogin
     * @request POST:/organisations/{organisationId}/authentication/login
     */
    employeeLogin: (
      organisationId: string,
      data: {
        password: string;
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmployeeJwtClaims, any>({
        path: `/organisations/${organisationId}/authentication/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name RequestEmployeePasswordReset
     * @request POST:/organisations/{organisationId}/authentication/request-password-reset
     */
    requestEmployeePasswordReset: (
      organisationId: string,
      data: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/authentication/request-password-reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ResetEmployeePassword
     * @request POST:/organisations/{organisationId}/authentication/password-reset
     */
    resetEmployeePassword: (organisationId: string, data: EmployeePasswordResetRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/authentication/password-reset`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  globalAuthentication = {
    /**
     * No description
     *
     * @tags GlobalAuthentication
     * @name GlobalAdminLogin
     * @request POST:/global/authentication/admin/login
     */
    globalAdminLogin: (
      data: {
        password: string;
        username: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GlobalAdminJwtClaims, any>({
        path: `/global/authentication/admin/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalAuthentication
     * @name ImpersonateEmployee
     * @request POST:/global/authentication/impersonate
     * @secure
     */
    impersonateEmployee: (data: ImpersonateEmployeeRequest, params: RequestParams = {}) =>
      this.request<EmployeeJwtClaims, any>({
        path: `/global/authentication/impersonate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  customerComments = {
    /**
     * No description
     *
     * @tags CustomerComments
     * @name GetCustomerComments
     * @request GET:/organisations/{organisationId}/customer-comments
     * @secure
     */
    getCustomerComments: (
      organisationId: string,
      query: {
        customerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerComment[], any>({
        path: `/organisations/${organisationId}/customer-comments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerComments
     * @name AddCustomerComment
     * @request POST:/organisations/{organisationId}/customer-comments
     * @secure
     */
    addCustomerComment: (
      organisationId: string,
      query: {
        customerId: string;
      },
      data: CustomerCommentCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerComment, any>({
        path: `/organisations/${organisationId}/customer-comments`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerComments
     * @name UpdateCustomerComment
     * @request PUT:/organisations/{organisationId}/customer-comments/{commentId}
     * @secure
     */
    updateCustomerComment: (
      organisationId: string,
      commentId: string,
      query: {
        customerId: string;
      },
      data: CustomerCommentUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CustomerComment, any>({
        path: `/organisations/${organisationId}/customer-comments/${commentId}`,
        method: 'PUT',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerComments
     * @name DeleteCustomerComment
     * @request DELETE:/organisations/{organisationId}/customer-comments/{commentId}
     * @secure
     */
    deleteCustomerComment: (
      organisationId: string,
      commentId: string,
      query: {
        customerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/customer-comments/${commentId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),
  };
  customers = {
    /**
     * No description
     *
     * @tags Customers
     * @name GetCustomerByEmail
     * @request GET:/organisations/{organisationId}/customers/email
     * @secure
     */
    getCustomerByEmail: (
      organisationId: string,
      query: {
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerUser | null, any>({
        path: `/organisations/${organisationId}/customers/email`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name CreateCustomer
     * @request POST:/organisations/{organisationId}/customers
     * @secure
     */
    createCustomer: (organisationId: string, data: CustomerCreateRequest, params: RequestParams = {}) =>
      this.request<CustomerUser, any>({
        path: `/organisations/${organisationId}/customers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetCustomers
     * @request GET:/organisations/{organisationId}/customers
     * @secure
     */
    getCustomers: (
      organisationId: string,
      query: {
        salonId: string;
        includeDeleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerUser[], any>({
        path: `/organisations/${organisationId}/customers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name UpdateCurrentCustomer
     * @request PUT:/organisations/{organisationId}/customers/me
     * @secure
     */
    updateCurrentCustomer: (organisationId: string, data: CurrentCustomerUpdateRequest, params: RequestParams = {}) =>
      this.request<CustomerUser, any>({
        path: `/organisations/${organisationId}/customers/me`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetCurrentCustomer
     * @request GET:/organisations/{organisationId}/customers/me
     * @secure
     */
    getCurrentCustomer: (organisationId: string, params: RequestParams = {}) =>
      this.request<CustomerUser, any>({
        path: `/organisations/${organisationId}/customers/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetCurrentCustomerDocuments
     * @request GET:/organisations/{organisationId}/customers/me/documents
     * @secure
     */
    getCurrentCustomerDocuments: (
      organisationId: string,
      query: {
        salonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CurrentCustomerDocument[], any>({
        path: `/organisations/${organisationId}/customers/me/documents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetCustomerActivities
     * @request GET:/organisations/{organisationId}/customers/activities
     * @secure
     */
    getCustomerActivities: (
      organisationId: string,
      query: {
        customerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerActivity[], any>({
        path: `/organisations/${organisationId}/customers/activities`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name UpdateCustomer
     * @request PUT:/organisations/{organisationId}/customers/{customerId}
     * @secure
     */
    updateCustomer: (organisationId: string, customerId: string, data: CustomerEditRequest, params: RequestParams = {}) =>
      this.request<CustomerUser, any>({
        path: `/organisations/${organisationId}/customers/${customerId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetCustomerDocuments
     * @request GET:/organisations/{organisationId}/customers/{customerId}/documents
     * @secure
     */
    getCustomerDocuments: (
      organisationId: string,
      customerId: string,
      query: {
        salonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerDocument[], any>({
        path: `/organisations/${organisationId}/customers/${customerId}/documents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name SendCustomerDocument
     * @request POST:/organisations/{organisationId}/customers/{customerId}/documents
     * @secure
     */
    sendCustomerDocument: (
      organisationId: string,
      customerId: string,
      query: {
        salonId: string;
      },
      data: SendCustomerDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/customers/${customerId}/documents`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name DeleteCustomerDocument
     * @request DELETE:/organisations/{organisationId}/customers/{customerId}/documents/{customerDocumentId}
     * @secure
     */
    deleteCustomerDocument: (
      organisationId: string,
      customerId: string,
      customerDocumentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/customers/${customerId}/documents/${customerDocumentId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name UpdateCustomerDocument
     * @request PUT:/organisations/{organisationId}/customers/{customerId}/documents/{documentId}
     * @secure
     */
    updateCustomerDocument: (
      organisationId: string,
      customerId: string,
      documentId: string,
      data: {
        status: CustomerConsentStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerDocument, any>({
        path: `/organisations/${organisationId}/customers/${customerId}/documents/${documentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name SearchCustomers
     * @request POST:/organisations/{organisationId}/customers/search
     * @secure
     */
    searchCustomers: (organisationId: string, data: CustomersSearchRequest, params: RequestParams = {}) =>
      this.request<CustomerUser[], any>({
        path: `/organisations/${organisationId}/customers/search`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetAllCustomers
     * @request GET:/organisations/{organisationId}/customers/all
     * @secure
     */
    getAllCustomers: (
      organisationId: string,
      query?: {
        includeDeleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerUser[], any>({
        path: `/organisations/${organisationId}/customers/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name GetCustomer
     * @request GET:/organisations/{organisationId}/customers/{id}
     * @secure
     */
    getCustomer: (
      organisationId: string,
      id: string,
      query: {
        salonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerUser | null, any>({
        path: `/organisations/${organisationId}/customers/${id}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name HardDeleteCustomer
     * @request DELETE:/organisations/{organisationId}/customers/{id}
     * @secure
     */
    hardDeleteCustomer: (organisationId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/customers/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name CreateCustomersInBulk
     * @request POST:/organisations/{organisationId}/customers/bulk
     * @secure
     */
    createCustomersInBulk: (organisationId: string, data: CustomersBulkCreateRequest, params: RequestParams = {}) =>
      this.request<
        {
          isNew: boolean;
          customer: CustomerUser;
        }[],
        any
      >({
        path: `/organisations/${organisationId}/customers/bulk`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name SendAdviceNotification
     * @request POST:/organisations/{organisationId}/customers/{id}/advice-notification
     * @secure
     */
    sendAdviceNotification: (
      organisationId: string,
      id: string,
      data: SendAdviceNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/customers/${id}/advice-notification`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  dashboardConfiguration = {
    /**
     * No description
     *
     * @tags DashboardConfiguration
     * @name GetDashboardsConfigurations
     * @request GET:/organisations/{organisationId}/salons/{salonId}/dashboard-configurations
     * @secure
     */
    getDashboardsConfigurations: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<DashboardConfiguration[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/dashboard-configurations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DashboardConfiguration
     * @name UpdateDashboardsConfigurations
     * @request POST:/organisations/{organisationId}/salons/{salonId}/dashboard-configurations
     * @secure
     */
    updateDashboardsConfigurations: (
      organisationId: string,
      salonId: string,
      data: DashboardConfigurationsUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<DashboardConfiguration[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/dashboard-configurations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  documents = {
    /**
     * No description
     *
     * @tags Documents
     * @name GetDocuments
     * @request GET:/organisations/{organisationId}/documents
     * @secure
     */
    getDocuments: (organisationId: string, params: RequestParams = {}) =>
      this.request<Document[], any>({
        path: `/organisations/${organisationId}/documents`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name CreateDocument
     * @request POST:/organisations/{organisationId}/documents
     * @secure
     */
    createDocument: (organisationId: string, data: DocumentCreateRequest, params: RequestParams = {}) =>
      this.request<Document, any>({
        path: `/organisations/${organisationId}/documents`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name UpdateDocument
     * @request PUT:/organisations/{organisationId}/documents/{documentId}
     * @secure
     */
    updateDocument: (organisationId: string, documentId: string, data: DocumentUpdateRequest, params: RequestParams = {}) =>
      this.request<Document, any>({
        path: `/organisations/${organisationId}/documents/${documentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  employees = {
    /**
     * No description
     *
     * @tags Employees
     * @name GetEmployees
     * @request GET:/organisations/{organisationId}/employees
     * @secure
     */
    getEmployees: (
      organisationId: string,
      query?: {
        salonId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmployeeUser[], any>({
        path: `/organisations/${organisationId}/employees`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employees
     * @name CreateEmployee
     * @request POST:/organisations/{organisationId}/employees
     * @secure
     */
    createEmployee: (organisationId: string, data: EmployeeCreateRequest, params: RequestParams = {}) =>
      this.request<EmployeeUser, any>({
        path: `/organisations/${organisationId}/employees`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employees
     * @name GetCurrentEmployeeData
     * @request GET:/organisations/{organisationId}/employees/me
     * @secure
     */
    getCurrentEmployeeData: (organisationId: string, params: RequestParams = {}) =>
      this.request<EmployeeUser, any>({
        path: `/organisations/${organisationId}/employees/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employees
     * @name GetEmployeesActivities
     * @request POST:/organisations/{organisationId}/employees/activities
     * @secure
     */
    getEmployeesActivities: (organisationId: string, data: EmployeeActivitySearchRequest, params: RequestParams = {}) =>
      this.request<EmployeeActivity[], any>({
        path: `/organisations/${organisationId}/employees/activities`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employees
     * @name GetEmployeeEffectivePermissions
     * @request GET:/organisations/{organisationId}/employees/{employeeId}/effectivePermissions
     * @secure
     */
    getEmployeeEffectivePermissions: (organisationId: string, employeeId: string, params: RequestParams = {}) =>
      this.request<EffectivePermissions, any>({
        path: `/organisations/${organisationId}/employees/${employeeId}/effectivePermissions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employees
     * @name UpdateCurrentEmployeeLanguage
     * @request PUT:/organisations/{organisationId}/employees/me/language
     * @secure
     */
    updateCurrentEmployeeLanguage: (
      organisationId: string,
      data: {
        language: SupportedLanguage;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmployeeUser, any>({
        path: `/organisations/${organisationId}/employees/me/language`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employees
     * @name UpdateEmployee
     * @request PUT:/organisations/{organisationId}/employees/{id}
     * @secure
     */
    updateEmployee: (organisationId: string, id: string, data: EmployeeEditRequest, params: RequestParams = {}) =>
      this.request<EmployeeUser, any>({
        path: `/organisations/${organisationId}/employees/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  customerSkinAnalysis = {
    /**
     * No description
     *
     * @tags CustomerSkinAnalysis
     * @name GetCustomerSkinAnalysis
     * @request GET:/organisations/{organisationId}/salons/{salonId}/customers/{customerId}/skin-analysis
     * @secure
     */
    getCustomerSkinAnalysis: (organisationId: string, salonId: string, customerId: string, params: RequestParams = {}) =>
      this.request<SkinAnalysis | null, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/customers/${customerId}/skin-analysis`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CustomerSkinAnalysis
     * @name UpdateCustomerSkinAnalysis
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/customers/{customerId}/skin-analysis
     * @secure
     */
    updateCustomerSkinAnalysis: (
      organisationId: string,
      salonId: string,
      customerId: string,
      data: SkinAnalysisUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<SkinAnalysis, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/customers/${customerId}/skin-analysis`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  googleCalendar = {
    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name GetConnectionStatus
     * @request GET:/organisations/{organisationId}/salons/{salonId}/google-calendar/status
     * @secure
     */
    getConnectionStatus: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<GoogleCalendarConnection, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name Connect
     * @request POST:/organisations/{organisationId}/salons/{salonId}/google-calendar/connect
     * @secure
     */
    connect: (organisationId: string, salonId: string, data: GoogleCalendarConnectRequest, params: RequestParams = {}) =>
      this.request<GoogleCalendarConnection, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/connect`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name Disconnect
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/google-calendar/disconnect
     * @secure
     */
    disconnect: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/disconnect`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name GetEvents
     * @request GET:/organisations/{organisationId}/salons/{salonId}/google-calendar/events
     * @secure
     */
    getEvents: (
      organisationId: string,
      salonId: string,
      query?: {
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GoogleCalendarEventsResponse, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/events`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name GetCalendars
     * @request GET:/organisations/{organisationId}/salons/{salonId}/google-calendar/calendars
     * @secure
     */
    getCalendars: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<GoogleCalendarListItem[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/calendars`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name SelectCalendar
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/google-calendar/calendar
     * @secure
     */
    selectCalendar: (organisationId: string, salonId: string, data: GoogleCalendarSelectRequest, params: RequestParams = {}) =>
      this.request<GoogleCalendarConnection, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/calendar`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name SetCalendarConfig
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/google-calendar/calendar-config
     * @secure
     */
    setCalendarConfig: (organisationId: string, salonId: string, data: GoogleCalendarConfigRequest, params: RequestParams = {}) =>
      this.request<GoogleCalendarConnection, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/calendar-config`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name Sync
     * @request POST:/organisations/{organisationId}/salons/{salonId}/google-calendar/sync
     * @secure
     */
    sync: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SalonizedSyncResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/sync`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name SyncPastYear
     * @request POST:/organisations/{organisationId}/salons/{salonId}/google-calendar/sync-past-year
     * @secure
     */
    syncPastYear: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SalonizedSyncResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/sync-past-year`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GoogleCalendar
     * @name GetOAuthUrl
     * @request GET:/organisations/{organisationId}/salons/{salonId}/google-calendar/oauth-url
     * @secure
     */
    getOAuthUrl: (
      organisationId: string,
      salonId: string,
      query: {
        redirectUri: string;
        state?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: string;
        },
        any
      >({
        path: `/organisations/${organisationId}/salons/${salonId}/google-calendar/oauth-url`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  healthCheck = {
    /**
     * No description
     *
     * @tags HealthCheck
     * @name HealthCheck
     * @request GET:/health-check
     */
    healthCheck: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/health-check`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HealthCheck
     * @name HealthCheckWithoutDbConnection
     * @request GET:/health-check/no-db
     */
    healthCheckWithoutDbConnection: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/health-check/no-db`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  globalJobs = {
    /**
     * No description
     *
     * @tags GlobalJobs
     * @name RunDailyQuestionnaires
     * @request POST:/global/jobs/daily-questionnaires/run
     * @secure
     */
    runDailyQuestionnaires: (data: RunDailyQuestionnairesRequest, params: RequestParams = {}) =>
      this.request<DailyQuestionnairesStats, any>({
        path: `/global/jobs/daily-questionnaires/run`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalJobs
     * @name RunSalonizedQuestionnaires
     * @request POST:/global/jobs/salonized-questionnaires/run
     * @secure
     */
    runSalonizedQuestionnaires: (data: RunDailyQuestionnairesRequest, params: RequestParams = {}) =>
      this.request<DailyQuestionnairesStats, any>({
        path: `/global/jobs/salonized-questionnaires/run`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalJobs
     * @name RunSalonizedSync
     * @request POST:/global/jobs/salonized-sync/run
     * @secure
     */
    runSalonizedSync: (data: RunDailyQuestionnairesRequest, params: RequestParams = {}) =>
      this.request<SalonizedSyncStats, any>({
        path: `/global/jobs/salonized-sync/run`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  messageTemplates = {
    /**
     * No description
     *
     * @tags MessageTemplates
     * @name GetNewQuestionnaireMessageTemplates
     * @request GET:/message-templates/new-questionnaire
     * @secure
     */
    getNewQuestionnaireMessageTemplates: (params: RequestParams = {}) =>
      this.request<MessageTemplate[], any>({
        path: `/message-templates/new-questionnaire`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  globalOrganisations = {
    /**
     * No description
     *
     * @tags GlobalOrganisations
     * @name GetOrganisations
     * @request GET:/global/organisations
     * @secure
     */
    getOrganisations: (params: RequestParams = {}) =>
      this.request<Organisation[], any>({
        path: `/global/organisations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalOrganisations
     * @name CreateOrganisation
     * @request POST:/global/organisations
     * @secure
     */
    createOrganisation: (data: GlobalAdminCreateOrganisationRequest, params: RequestParams = {}) =>
      this.request<Organisation, any>({
        path: `/global/organisations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalOrganisations
     * @name UpdateOrganisation
     * @request PUT:/global/organisations
     * @secure
     */
    updateOrganisation: (data: GlobalAdminUpdateOrganisationRequest, params: RequestParams = {}) =>
      this.request<Organisation, any>({
        path: `/global/organisations`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalOrganisations
     * @name UpdateOrganisationInvoicingData
     * @request PUT:/global/organisations/invoicing-data
     * @secure
     */
    updateOrganisationInvoicingData: (data: GlobalAdminUpdateOrganisationInvoicingDataRequest, params: RequestParams = {}) =>
      this.request<OrganisationInvoicingData, any>({
        path: `/global/organisations/invoicing-data`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalOrganisations
     * @name DropOrganisation
     * @request DELETE:/global/organisations/{organisationId}
     * @secure
     */
    dropOrganisation: (organisationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/organisations/${organisationId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalOrganisations
     * @name GetDiscountCodes
     * @request GET:/global/organisations/discount-codes
     * @secure
     */
    getDiscountCodes: (params: RequestParams = {}) =>
      this.request<GlobalDiscountCode[], any>({
        path: `/global/organisations/discount-codes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  organisations = {
    /**
     * No description
     *
     * @tags Organisations
     * @name GetOrganisationCreateChallenge
     * @request GET:/organisations/challenge
     */
    getOrganisationCreateChallenge: (
      query: {
        confirmation: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Challenge, any>({
        path: `/organisations/challenge`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name GetPublicOrganisationBySlugOrName
     * @request GET:/organisations/public
     */
    getPublicOrganisationBySlugOrName: (
      query?: {
        slug?: string;
        name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PublicOrganisation | null, any>({
        path: `/organisations/public`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name GetOrganisationCustomerSettings
     * @request GET:/organisations/{organisationId}/customer-settings
     * @secure
     */
    getOrganisationCustomerSettings: (organisationId: string, params: RequestParams = {}) =>
      this.request<OrganisationCustomerSettings, any>({
        path: `/organisations/${organisationId}/customer-settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name GetOrganisation
     * @request GET:/organisations/{organisationId}
     * @secure
     */
    getOrganisation: (organisationId: string, params: RequestParams = {}) =>
      this.request<Organisation | null, any>({
        path: `/organisations/${organisationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name UpdateOrganisation
     * @request PUT:/organisations/{organisationId}
     * @secure
     */
    updateOrganisation: (organisationId: string, data: OrganisationUpdateRequest, params: RequestParams = {}) =>
      this.request<Organisation, any>({
        path: `/organisations/${organisationId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name GetOrganisationInvoicingData
     * @request GET:/organisations/{organisationId}/invoicing-data
     * @secure
     */
    getOrganisationInvoicingData: (organisationId: string, params: RequestParams = {}) =>
      this.request<OrganisationInvoicingData | null, any>({
        path: `/organisations/${organisationId}/invoicing-data`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name UpdateOrganisationInvoicingData
     * @request PUT:/organisations/{organisationId}/invoicing-data
     * @secure
     */
    updateOrganisationInvoicingData: (
      organisationId: string,
      data: OrganisationInvoicingDataUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrganisationInvoicingData, any>({
        path: `/organisations/${organisationId}/invoicing-data`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organisations
     * @name CreateOrganisation
     * @request POST:/organisations
     */
    createOrganisation: (data: OrganisationCreateRequest, params: RequestParams = {}) =>
      this.request<
        {
          employee: EmployeeUser;
          organisation: Organisation;
        },
        any
      >({
        path: `/organisations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  globalPaidCourses = {
    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name GetCourses
     * @request GET:/global/paid-courses
     * @secure
     */
    getCourses: (params: RequestParams = {}) =>
      this.request<GlobalPaidCourse[], any>({
        path: `/global/paid-courses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name CreateCourse
     * @request POST:/global/paid-courses
     * @secure
     */
    createCourse: (data: PaidCourseCreateRequest, params: RequestParams = {}) =>
      this.request<GlobalPaidCourse, any>({
        path: `/global/paid-courses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name ReorderCourses
     * @request PUT:/global/paid-courses/order
     * @secure
     */
    reorderCourses: (data: ReorderRequest, params: RequestParams = {}) =>
      this.request<GlobalPaidCourse[], any>({
        path: `/global/paid-courses/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name UpdateCourse
     * @request PUT:/global/paid-courses/{courseId}
     * @secure
     */
    updateCourse: (courseId: string, data: PaidCourseUpdateRequest, params: RequestParams = {}) =>
      this.request<GlobalPaidCourse, any>({
        path: `/global/paid-courses/${courseId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name DeleteCourse
     * @request DELETE:/global/paid-courses/{courseId}
     * @secure
     */
    deleteCourse: (courseId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/paid-courses/${courseId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name GetModules
     * @request GET:/global/paid-courses/{courseId}/modules
     * @secure
     */
    getModules: (courseId: string, params: RequestParams = {}) =>
      this.request<Module[], any>({
        path: `/global/paid-courses/${courseId}/modules`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name CreateModule
     * @request POST:/global/paid-courses/{courseId}/modules
     * @secure
     */
    createModule: (courseId: string, data: ModuleCreateRequest, params: RequestParams = {}) =>
      this.request<Module, any>({
        path: `/global/paid-courses/${courseId}/modules`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name ReorderModules
     * @request PUT:/global/paid-courses/{courseId}/modules/order
     * @secure
     */
    reorderModules: (courseId: string, data: ReorderRequest, params: RequestParams = {}) =>
      this.request<Module[], any>({
        path: `/global/paid-courses/${courseId}/modules/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name UpdateModule
     * @request PUT:/global/paid-courses/{courseId}/modules/{moduleId}
     * @secure
     */
    updateModule: (courseId: string, moduleId: string, data: ModuleUpdateRequest, params: RequestParams = {}) =>
      this.request<Module, any>({
        path: `/global/paid-courses/${courseId}/modules/${moduleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalPaidCourses
     * @name DeleteModule
     * @request DELETE:/global/paid-courses/{courseId}/modules/{moduleId}
     * @secure
     */
    deleteModule: (courseId: string, moduleId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/paid-courses/${courseId}/modules/${moduleId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  paidCourses = {
    /**
     * No description
     *
     * @tags PaidCourses
     * @name GetCourses
     * @request GET:/organisations/{organisationId}/paid-courses
     * @secure
     */
    getCourses: (organisationId: string, params: RequestParams = {}) =>
      this.request<PaidCourse[], any>({
        path: `/organisations/${organisationId}/paid-courses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaidCourses
     * @name CreateCoursePayment
     * @request POST:/organisations/{organisationId}/paid-courses/{courseId}/payment
     * @secure
     */
    createCoursePayment: (
      organisationId: string,
      courseId: string,
      query: {
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaidCoursePaymentCreateResponse, any>({
        path: `/organisations/${organisationId}/paid-courses/${courseId}/payment`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaidCourses
     * @name GetModules
     * @request GET:/organisations/{organisationId}/paid-courses/{courseId}/modules
     * @secure
     */
    getModules: (courseId: string, organisationId: string, params: RequestParams = {}) =>
      this.request<Module[], any>({
        path: `/organisations/${organisationId}/paid-courses/${courseId}/modules`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaidCourses
     * @name GetPaidCourseDiscountCode
     * @request GET:/organisations/{organisationId}/paid-courses/{courseId}/discount-codes/{code}
     * @secure
     */
    getPaidCourseDiscountCode: (organisationId: string, code: string, courseId: string, params: RequestParams = {}) =>
      this.request<DiscountCode, any>({
        path: `/organisations/${organisationId}/paid-courses/${courseId}/discount-codes/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  permissions = {
    /**
     * No description
     *
     * @tags Permissions
     * @name GetRoles
     * @request GET:/organisations/{organisationId}/permissions/roles
     * @secure
     */
    getRoles: (organisationId: string, params: RequestParams = {}) =>
      this.request<SalonRole[], any>({
        path: `/organisations/${organisationId}/permissions/roles`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name CreateRole
     * @request POST:/organisations/{organisationId}/permissions/roles
     * @secure
     */
    createRole: (organisationId: string, data: SalonRoleCreateRequest, params: RequestParams = {}) =>
      this.request<SalonRole, any>({
        path: `/organisations/${organisationId}/permissions/roles`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name UpdateRole
     * @request PUT:/organisations/{organisationId}/permissions/roles/{roleId}
     * @secure
     */
    updateRole: (organisationId: string, roleId: string, data: SalonRoleUpdateRequest, params: RequestParams = {}) =>
      this.request<SalonRole, any>({
        path: `/organisations/${organisationId}/permissions/roles/${roleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  photoSets = {
    /**
     * No description
     *
     * @tags PhotoSets
     * @name GetSets
     * @request GET:/organisations/{organisationId}/salons/{salonId}/photo-sets
     * @secure
     */
    getSets: (
      organisationId: string,
      salonId: string,
      query: {
        customerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PhotoSet[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhotoSets
     * @name CreateSet
     * @request POST:/organisations/{organisationId}/salons/{salonId}/photo-sets
     * @secure
     */
    createSet: (organisationId: string, salonId: string, data: PhotoSetCreateRequest, params: RequestParams = {}) =>
      this.request<PhotoSet, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhotoSets
     * @name GetMine
     * @request GET:/organisations/{organisationId}/salons/{salonId}/photo-sets/mine
     * @secure
     */
    getMine: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<PhotoSet[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets/mine`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhotoSets
     * @name UpdateSet
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/photo-sets/{setId}
     * @secure
     */
    updateSet: (
      organisationId: string,
      salonId: string,
      setId: string,
      data: PhotoSetUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PhotoSet, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets/${setId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhotoSets
     * @name DeleteSet
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/photo-sets/{setId}
     * @secure
     */
    deleteSet: (organisationId: string, salonId: string, setId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets/${setId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhotoSets
     * @name UploadPhoto
     * @request POST:/organisations/{organisationId}/salons/{salonId}/photo-sets/{setId}/photos/{angle}
     * @secure
     */
    uploadPhoto: (
      organisationId: string,
      salonId: string,
      setId: string,
      angle: string,
      data: {
        /** @format binary */
        file: File;
        transform?: string;
        alignment?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PhotoSet, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets/${setId}/photos/${angle}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhotoSets
     * @name DeletePhoto
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/photo-sets/{setId}/photos/{angle}
     * @secure
     */
    deletePhoto: (organisationId: string, salonId: string, setId: string, angle: string, params: RequestParams = {}) =>
      this.request<PhotoSet, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets/${setId}/photos/${angle}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhotoSets
     * @name UpdateTransform
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/photo-sets/{setId}/photos/{angle}/transform
     * @secure
     */
    updateTransform: (
      organisationId: string,
      salonId: string,
      setId: string,
      angle: string,
      data: PhotoTransformRequest,
      params: RequestParams = {},
    ) =>
      this.request<PhotoSet, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/photo-sets/${setId}/photos/${angle}/transform`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  plans = {
    /**
     * No description
     *
     * @tags Plans
     * @name GetPlans
     * @request GET:/organisations/{organisationId}/salons/{salonId}/plans
     * @secure
     */
    getPlans: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<Plan[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name CreatePlan
     * @request POST:/organisations/{organisationId}/salons/{salonId}/plans
     * @secure
     */
    createPlan: (organisationId: string, salonId: string, data: PlanCreateRequest, params: RequestParams = {}) =>
      this.request<Plan, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name SetOfferStatus
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/plans/offers/{offerId}/status
     * @secure
     */
    setOfferStatus: (
      organisationId: string,
      salonId: string,
      offerId: string,
      data: SetPlanOfferStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlanOfferOverview, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/offers/${offerId}/status`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name SetOfferMembership
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/plans/offers/{offerId}/membership
     * @secure
     */
    setOfferMembership: (
      organisationId: string,
      salonId: string,
      offerId: string,
      data: SetPlanOfferMembershipRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlanOfferOverview, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/offers/${offerId}/membership`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name UpdateOffer
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/plans/offers/{offerId}
     * @secure
     */
    updateOffer: (
      organisationId: string,
      salonId: string,
      offerId: string,
      data: UpdatePlanOfferRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlanOfferOverview, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/offers/${offerId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name SendAsk
     * @request POST:/organisations/{organisationId}/salons/{salonId}/plans/offers/{offerId}/send-ask
     * @secure
     */
    sendAsk: (organisationId: string, salonId: string, offerId: string, params: RequestParams = {}) =>
      this.request<PlanOfferOverview, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/offers/${offerId}/send-ask`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name GeneratePlanningProposal
     * @request POST:/organisations/{organisationId}/salons/{salonId}/plans/offers/{offerId}/planning-proposal
     * @secure
     */
    generatePlanningProposal: (
      organisationId: string,
      salonId: string,
      offerId: string,
      data: GeneratePlanningProposalRequest,
      params: RequestParams = {},
    ) =>
      this.request<PlanOfferOverview, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/offers/${offerId}/planning-proposal`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name SendAskAll
     * @request POST:/organisations/{organisationId}/salons/{salonId}/plans/{planId}/send-ask
     * @secure
     */
    sendAskAll: (organisationId: string, salonId: string, planId: string, params: RequestParams = {}) =>
      this.request<SendPlanAskResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/${planId}/send-ask`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name AddOffers
     * @request POST:/organisations/{organisationId}/salons/{salonId}/plans/{planId}/offers
     * @secure
     */
    addOffers: (
      organisationId: string,
      salonId: string,
      planId: string,
      data: AddPlanOffersRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddPlanOffersResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/${planId}/offers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name GetOffers
     * @request GET:/organisations/{organisationId}/salons/{salonId}/plans/{planId}/offers
     * @secure
     */
    getOffers: (organisationId: string, salonId: string, planId: string, params: RequestParams = {}) =>
      this.request<PlanOfferOverview[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/${planId}/offers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name GetCustomerOffers
     * @request GET:/organisations/{organisationId}/salons/{salonId}/plans/customer/{customerId}/offers
     * @secure
     */
    getCustomerOffers: (organisationId: string, salonId: string, customerId: string, params: RequestParams = {}) =>
      this.request<CustomerPlanOffer[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/customer/${customerId}/offers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name UpdatePlan
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/plans/{planId}
     * @secure
     */
    updatePlan: (organisationId: string, salonId: string, planId: string, data: PlanUpdateRequest, params: RequestParams = {}) =>
      this.request<Plan, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/${planId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Plans
     * @name DeletePlan
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/plans/{planId}
     * @secure
     */
    deletePlan: (organisationId: string, salonId: string, planId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/plans/${planId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  publicPlanOffers = {
    /**
     * No description
     *
     * @tags PublicPlanOffers
     * @name Resolve
     * @request POST:/public-plan-offers/resolve
     */
    resolve: (data: ResolvePlanOfferRequest, params: RequestParams = {}) =>
      this.request<PlanOfferPublicView, any>({
        path: `/public-plan-offers/resolve`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicPlanOffers
     * @name Respond
     * @request POST:/public-plan-offers/respond
     */
    respond: (data: RespondPlanOfferRequest, params: RequestParams = {}) =>
      this.request<PlanOfferPublicView, any>({
        path: `/public-plan-offers/respond`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  questionnaires = {
    /**
     * No description
     *
     * @tags Questionnaires
     * @name CreateQuestionnaireSubmissionRequest
     * @request POST:/organisations/{organisationId}/salons/{salonId}/questionnaireSubmissions
     * @secure
     */
    createQuestionnaireSubmissionRequest: (
      organisationId: string,
      salonId: string,
      data: QuestionnaireSubmissionRequest,
      params: RequestParams = {},
    ) =>
      this.request<QuestionnaireSubmission, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaireSubmissions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name GetCustomerQuestionnaireSubmissions
     * @request GET:/organisations/{organisationId}/salons/{salonId}/questionnaireSubmissions
     * @secure
     */
    getCustomerQuestionnaireSubmissions: (
      organisationId: string,
      salonId: string,
      query: {
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionnaireSubmission[] | null, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaireSubmissions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name GetRecentCustomerQuestionnaireSubmissions
     * @request GET:/organisations/{organisationId}/salons/{salonId}/questionnaireSubmissions/recent
     * @secure
     */
    getRecentCustomerQuestionnaireSubmissions: (
      organisationId: string,
      salonId: string,
      query: {
        userId: string;
        complete?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionnaireSubmission[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaireSubmissions/recent`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name GetSalonSubmissions
     * @request GET:/organisations/{organisationId}/salons/{salonId}/questionnaireSubmissions/salon
     * @secure
     */
    getSalonSubmissions: (
      organisationId: string,
      salonId: string,
      query?: {
        questionnaireId?: string;
        complete?: boolean;
        /** @format double */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalonSubmissionOverview[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaireSubmissions/salon`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name GetQuestionnaireSubmission
     * @request GET:/organisations/{organisationId}/salons/{salonId}/questionnaireSubmissions/{questionnaireSubmissionId}
     * @secure
     */
    getQuestionnaireSubmission: (
      organisationId: string,
      salonId: string,
      questionnaireSubmissionId: string,
      params: RequestParams = {},
    ) =>
      this.request<QuestionnaireSubmission, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaireSubmissions/${questionnaireSubmissionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name AddQuestionSubmission
     * @request POST:/organisations/{organisationId}/salons/{salonId}/questionnaireSubmissions/{questionnaireSubmissionId}/questionSubmission
     * @secure
     */
    addQuestionSubmission: (
      organisationId: string,
      salonId: string,
      questionnaireSubmissionId: string,
      data: {
        isLastQuestion: boolean;
        answer?: string[];
        questionId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QuestionSubmission | null, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaireSubmissions/${questionnaireSubmissionId}/questionSubmission`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name GetQuestionnaire
     * @request GET:/organisations/{organisationId}/salons/{salonId}/questionnaires/{questionnaireId}
     * @secure
     */
    getQuestionnaire: (organisationId: string, salonId: string, questionnaireId: string, params: RequestParams = {}) =>
      this.request<Questionnaire, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaires/${questionnaireId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name UpdateQuestionnaire
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/questionnaires/{questionnaireId}
     * @secure
     */
    updateQuestionnaire: (
      organisationId: string,
      salonId: string,
      questionnaireId: string,
      data: QuestionnaireUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<Questionnaire, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaires/${questionnaireId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name GetQuestionnaires
     * @request GET:/organisations/{organisationId}/salons/{salonId}/questionnaires
     * @secure
     */
    getQuestionnaires: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<Questionnaire[] | null, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaires`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name CreateQuestionnaire
     * @request POST:/organisations/{organisationId}/salons/{salonId}/questionnaires
     * @secure
     */
    createQuestionnaire: (
      organisationId: string,
      salonId: string,
      data: QuestionnaireCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<Questionnaire, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaires`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name UpdateSortOrder
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/questionnaires/sort-order
     * @secure
     */
    updateSortOrder: (
      organisationId: string,
      salonId: string,
      data: {
        items: {
          /** @format double */
          sortOrder: number;
          questionnaireId: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaires/sort-order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name SetPublicLink
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/questionnaires/{questionnaireId}/public-link
     * @secure
     */
    setPublicLink: (
      organisationId: string,
      salonId: string,
      questionnaireId: string,
      data: {
        enabled: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Questionnaire, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaires/${questionnaireId}/public-link`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Questionnaires
     * @name ExportQuestionnaire
     * @request GET:/organisations/{organisationId}/salons/{salonId}/questionnaires/{questionnaireId}/export
     * @secure
     */
    exportQuestionnaire: (organisationId: string, salonId: string, questionnaireId: string, params: RequestParams = {}) =>
      this.request<ExpressMulterFile, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/questionnaires/${questionnaireId}/export`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  globalQuestionnaires = {
    /**
     * No description
     *
     * @tags GlobalQuestionnaires
     * @name GetTemplateOrganisationQuestionnaires
     * @request GET:/global/questionnaires
     * @secure
     */
    getTemplateOrganisationQuestionnaires: (params: RequestParams = {}) =>
      this.request<Questionnaire[], any>({
        path: `/global/questionnaires`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalQuestionnaires
     * @name SyncQuestionnairesToOrganisations
     * @request PUT:/global/questionnaires/sync
     * @secure
     */
    syncQuestionnairesToOrganisations: (data: SyncQuestionnairesToOrganisationsRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/questionnaires/sync`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  publicQuestionnaires = {
    /**
     * No description
     *
     * @tags PublicQuestionnaires
     * @name GetChallenge
     * @request GET:/public-questionnaires/challenge
     */
    getChallenge: (
      query: {
        publicToken: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Challenge, any>({
        path: `/public-questionnaires/challenge`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicQuestionnaires
     * @name Resolve
     * @request POST:/public-questionnaires/resolve
     */
    resolve: (data: PublicQuestionnaireResolveRequest, params: RequestParams = {}) =>
      this.request<PublicQuestionnaireResolveResponse, any>({
        path: `/public-questionnaires/resolve`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicQuestionnaires
     * @name RequestCode
     * @request POST:/public-questionnaires/request-code
     */
    requestCode: (data: PublicQuestionnaireRequestCodeRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/public-questionnaires/request-code`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PublicQuestionnaires
     * @name Verify
     * @request POST:/public-questionnaires/verify
     */
    verify: (data: PublicQuestionnaireVerifyRequest, params: RequestParams = {}) =>
      this.request<PublicQuestionnaireVerifyResponse, any>({
        path: `/public-questionnaires/verify`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  sales = {
    /**
     * No description
     *
     * @tags Sales
     * @name ImportSales
     * @request POST:/organisations/{organisationId}/salons/{salonId}/sales/import
     * @secure
     */
    importSales: (organisationId: string, salonId: string, data: SaleImportRequest, params: RequestParams = {}) =>
      this.request<SaleImportResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sales/import`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sales
     * @name GetImports
     * @request GET:/organisations/{organisationId}/salons/{salonId}/sales/imports
     * @secure
     */
    getImports: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SaleImportOverview[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sales/imports`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sales
     * @name GetCustomerSales
     * @request GET:/organisations/{organisationId}/salons/{salonId}/sales/customer/{customerId}
     * @secure
     */
    getCustomerSales: (organisationId: string, salonId: string, customerId: string, params: RequestParams = {}) =>
      this.request<CustomerSale[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sales/customer/${customerId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  salonized = {
    /**
     * No description
     *
     * @tags Salonized
     * @name GetConnectionStatus
     * @request GET:/organisations/{organisationId}/salons/{salonId}/salonized/status
     * @secure
     */
    getConnectionStatus: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SalonizedStatus, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name Connect
     * @request POST:/organisations/{organisationId}/salons/{salonId}/salonized/connect
     * @secure
     */
    connect: (organisationId: string, salonId: string, data: SalonizedConnectRequest, params: RequestParams = {}) =>
      this.request<SalonizedStatus, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/connect`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name Disconnect
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/salonized/disconnect
     * @secure
     */
    disconnect: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/disconnect`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name Sync
     * @request POST:/organisations/{organisationId}/salons/{salonId}/salonized/sync
     * @secure
     */
    sync: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SalonizedSyncResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/sync`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name SyncPastYear
     * @request POST:/organisations/{organisationId}/salons/{salonId}/salonized/sync-past-year
     * @secure
     */
    syncPastYear: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SalonizedSyncResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/sync-past-year`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name DeleteAllAppointments
     * @request POST:/organisations/{organisationId}/salons/{salonId}/salonized/delete-appointments
     * @secure
     */
    deleteAllAppointments: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SalonizedDeleteResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/delete-appointments`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name GetStoredAppointments
     * @request GET:/organisations/{organisationId}/salons/{salonId}/salonized/appointments
     * @secure
     */
    getStoredAppointments: (
      organisationId: string,
      salonId: string,
      query?: {
        from?: string;
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalonizedStoredAppointment[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/appointments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name GetTreatmentCounts
     * @request GET:/organisations/{organisationId}/salons/{salonId}/salonized/treatment-counts
     * @secure
     */
    getTreatmentCounts: (
      organisationId: string,
      salonId: string,
      query: {
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalonizedTreatmentCount[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/treatment-counts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name GetCustomerAppointments
     * @request GET:/organisations/{organisationId}/salons/{salonId}/salonized/customer-appointments
     * @secure
     */
    getCustomerAppointments: (
      organisationId: string,
      salonId: string,
      query: {
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalonizedCustomerAppointment[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/customer-appointments`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name SendCareQuestionnaire
     * @request POST:/organisations/{organisationId}/salons/{salonId}/salonized/appointments/{appointmentId}/send
     * @secure
     */
    sendCareQuestionnaire: (
      organisationId: string,
      salonId: string,
      appointmentId: string,
      data: SalonizedSendCareRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/appointments/${appointmentId}/send`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salonized
     * @name GetAgendaWeek
     * @request GET:/organisations/{organisationId}/salons/{salonId}/salonized/agenda-week
     * @secure
     */
    getAgendaWeek: (
      organisationId: string,
      salonId: string,
      query?: {
        from?: string;
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalonizedAgendaWeek, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/salonized/agenda-week`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  salons = {
    /**
     * No description
     *
     * @tags Salons
     * @name GetSalons
     * @request GET:/organisations/{organisationId}/salons
     * @secure
     */
    getSalons: (organisationId: string, params: RequestParams = {}) =>
      this.request<Salon[], any>({
        path: `/organisations/${organisationId}/salons`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salons
     * @name CreateSalon
     * @request POST:/organisations/{organisationId}/salons
     * @secure
     */
    createSalon: (organisationId: string, data: SalonCreateRequest, params: RequestParams = {}) =>
      this.request<Salon, any>({
        path: `/organisations/${organisationId}/salons`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salons
     * @name GetSalon
     * @request GET:/organisations/{organisationId}/salons/{salonId}
     * @secure
     */
    getSalon: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<Salon | null, any>({
        path: `/organisations/${organisationId}/salons/${salonId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Salons
     * @name UpdateSalon
     * @request PUT:/organisations/{organisationId}/salons/{id}
     * @secure
     */
    updateSalon: (organisationId: string, id: string, data: SalonUpdateRequest, params: RequestParams = {}) =>
      this.request<Salon, any>({
        path: `/organisations/${organisationId}/salons/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  shortcuts = {
    /**
     * No description
     *
     * @tags Shortcuts
     * @name GetShortcutData
     * @request GET:/shortcuts
     */
    getShortcutData: (
      query: {
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          data: string;
        } | null,
        any
      >({
        path: `/shortcuts`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  sneladvies = {
    /**
     * No description
     *
     * @tags Sneladvies
     * @name GetBlocks
     * @request GET:/organisations/{organisationId}/salons/{salonId}/sneladvies
     * @secure
     */
    getBlocks: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SneladviesBlock[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sneladvies`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sneladvies
     * @name CreateBlock
     * @request POST:/organisations/{organisationId}/salons/{salonId}/sneladvies
     * @secure
     */
    createBlock: (organisationId: string, salonId: string, data: SneladviesBlockCreateRequest, params: RequestParams = {}) =>
      this.request<SneladviesBlock, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sneladvies`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sneladvies
     * @name TranslateBlock
     * @request POST:/organisations/{organisationId}/salons/{salonId}/sneladvies/translate
     * @secure
     */
    translateBlock: (organisationId: string, salonId: string, data: SneladviesTranslateRequest, params: RequestParams = {}) =>
      this.request<SneladviesTranslateResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sneladvies/translate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sneladvies
     * @name GetMine
     * @request GET:/organisations/{organisationId}/salons/{salonId}/sneladvies/mine
     * @secure
     */
    getMine: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SneladviesBlock[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sneladvies/mine`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sneladvies
     * @name SetSelection
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/sneladvies/customer/{customerId}/selection
     * @secure
     */
    setSelection: (
      organisationId: string,
      salonId: string,
      customerId: string,
      data: SetSneladviesSelectionRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sneladvies/customer/${customerId}/selection`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sneladvies
     * @name UpdateBlock
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/sneladvies/{blockId}
     * @secure
     */
    updateBlock: (
      organisationId: string,
      salonId: string,
      blockId: string,
      data: SneladviesBlockUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<SneladviesBlock, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sneladvies/${blockId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Sneladvies
     * @name DeleteBlock
     * @request DELETE:/organisations/{organisationId}/salons/{salonId}/sneladvies/{blockId}
     * @secure
     */
    deleteBlock: (organisationId: string, salonId: string, blockId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/sneladvies/${blockId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  globalSpokenAdviceConfig = {
    /**
     * No description
     *
     * @tags GlobalSpokenAdviceConfig
     * @name GetConfig
     * @request GET:/global/spoken-advice-config
     * @secure
     */
    getConfig: (params: RequestParams = {}) =>
      this.request<SpokenAdviceConfig, any>({
        path: `/global/spoken-advice-config`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalSpokenAdviceConfig
     * @name UpdateConfig
     * @request PUT:/global/spoken-advice-config
     * @secure
     */
    updateConfig: (data: SpokenAdviceConfig, params: RequestParams = {}) =>
      this.request<SpokenAdviceConfig, any>({
        path: `/global/spoken-advice-config`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  spokenAdvice = {
    /**
     * No description
     *
     * @tags SpokenAdvice
     * @name Generate
     * @request POST:/organisations/{organisationId}/salons/{salonId}/spoken-advice/generate
     * @secure
     */
    generate: (
      organisationId: string,
      salonId: string,
      data: {
        userId: string;
        /** @format binary */
        audio: File;
        salonizedAppointmentExternalId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GenerateSpokenAdviceResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/spoken-advice/generate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpokenAdvice
     * @name Get
     * @request GET:/organisations/{organisationId}/salons/{salonId}/spoken-advice
     * @secure
     */
    get: (
      organisationId: string,
      salonId: string,
      query: {
        userId: string;
        salonizedAppointmentExternalId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SpokenAdvice[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/spoken-advice`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpokenAdvice
     * @name GetConfig
     * @request GET:/organisations/{organisationId}/salons/{salonId}/spoken-advice/config
     * @secure
     */
    getConfig: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<SpokenAdviceConfigPublic, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/spoken-advice/config`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpokenAdvice
     * @name SetClassifications
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/spoken-advice/classifications
     * @secure
     */
    setClassifications: (
      organisationId: string,
      salonId: string,
      data: SetSpokenClassificationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/spoken-advice/classifications`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpokenAdvice
     * @name Update
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/spoken-advice/{adviceId}
     * @secure
     */
    update: (
      organisationId: string,
      salonId: string,
      adviceId: string,
      data: UpdateSpokenAdviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<SpokenAdvice, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/spoken-advice/${adviceId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  staffMessages = {
    /**
     * No description
     *
     * @tags StaffMessages
     * @name GetMyMessages
     * @request GET:/organisations/{organisationId}/salons/{salonId}/staff-messages
     * @secure
     */
    getMyMessages: (organisationId: string, salonId: string, params: RequestParams = {}) =>
      this.request<StaffMessage[], any>({
        path: `/organisations/${organisationId}/salons/${salonId}/staff-messages`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags StaffMessages
     * @name MarkAsRead
     * @request PUT:/organisations/{organisationId}/salons/{salonId}/staff-messages/{messageId}/read
     * @secure
     */
    markAsRead: (organisationId: string, salonId: string, messageId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/staff-messages/${messageId}/read`,
        method: 'PUT',
        secure: true,
        ...params,
      }),
  };
  globalSubscriptions = {
    /**
     * No description
     *
     * @tags GlobalSubscriptions
     * @name GetSubscriptionsOptions
     * @request GET:/global/subscriptions/options
     */
    getSubscriptionsOptions: (params: RequestParams = {}) =>
      this.request<SubscriptionOption[], any>({
        path: `/global/subscriptions/options`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalSubscriptions
     * @name CreateSubscriptionOption
     * @request POST:/global/subscriptions/options
     * @secure
     */
    createSubscriptionOption: (data: SubscriptionOptionCreateRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/subscriptions/options`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalSubscriptions
     * @name ReorderSubscriptionOptions
     * @request PUT:/global/subscriptions/options/order
     * @secure
     */
    reorderSubscriptionOptions: (data: ReorderRequest, params: RequestParams = {}) =>
      this.request<SubscriptionOption[], any>({
        path: `/global/subscriptions/options/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalSubscriptions
     * @name UpdateSubscriptionOption
     * @request PUT:/global/subscriptions/options/{optionId}
     * @secure
     */
    updateSubscriptionOption: (optionId: string, data: SubscriptionOptionUpdateRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/global/subscriptions/options/${optionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalSubscriptions
     * @name CancelCustomerSubscription
     * @request DELETE:/global/subscriptions/customer-subscriptions/{subscriptionId}
     * @secure
     */
    cancelCustomerSubscription: (
      subscriptionId: string,
      query: {
        mollieCustomerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/global/subscriptions/customer-subscriptions/${subscriptionId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalSubscriptions
     * @name FetchCustomersSubscriptions
     * @request GET:/global/subscriptions/customer-subscriptions
     * @secure
     */
    fetchCustomersSubscriptions: (params: RequestParams = {}) =>
      this.request<MollieCustomerSubscription[], any>({
        path: `/global/subscriptions/customer-subscriptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalSubscriptions
     * @name GetSubscriptionOptionsDiscountCode
     * @request GET:/global/subscriptions/option-payment/discount-code
     */
    getSubscriptionOptionsDiscountCode: (
      query: {
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          discountCode: DiscountCode;
          subscriptionOptionIds: string[];
        },
        any
      >({
        path: `/global/subscriptions/option-payment/discount-code`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  paymentsWebhooks = {
    /**
     * No description
     *
     * @tags PaymentsWebhooks
     * @name SubscriptionOptionsPaymentWebhook
     * @request POST:/organisations/{organisationId}/subscription-options/payments/webhook
     */
    subscriptionOptionsPaymentWebhook: (
      organisationId: string,
      data: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/subscription-options/payments/webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentsWebhooks
     * @name SubscriptionOptionsRecurringPaymentWebhook
     * @request POST:/organisations/{organisationId}/subscription/recurring-payments/webhook
     */
    subscriptionOptionsRecurringPaymentWebhook: (
      organisationId: string,
      data: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/subscription/recurring-payments/webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentsWebhooks
     * @name PaidCoursesPaymentWebhook
     * @request POST:/organisations/{organisationId}/paid-courses/payments/webhook
     */
    paidCoursesPaymentWebhook: (
      organisationId: string,
      data: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/paid-courses/payments/webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentsWebhooks
     * @name WhatsappCreditsPaymentWebhook
     * @request POST:/organisations/{organisationId}/whatsapp-credits/payments/webhook
     */
    whatsappCreditsPaymentWebhook: (
      organisationId: string,
      data: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/whatsapp-credits/payments/webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentsWebhooks
     * @name AssistantCreditsPaymentWebhook
     * @request POST:/organisations/{organisationId}/assistant-credits/payments/webhook
     */
    assistantCreditsPaymentWebhook: (
      organisationId: string,
      data: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/assistant-credits/payments/webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentsWebhooks
     * @name PlugAndPayNewOrder
     * @request POST:/organisations/plug-and-pay/new-organisation/webhook
     */
    plugAndPayNewOrder: (data: IRecordOfAny, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/plug-and-pay/new-organisation/webhook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  subscriptions = {
    /**
     * No description
     *
     * @tags Subscriptions
     * @name GetSubscription
     * @request GET:/organisations/{organisationId}/subscriptions
     * @secure
     */
    getSubscription: (organisationId: string, params: RequestParams = {}) =>
      this.request<Subscription, any>({
        path: `/organisations/${organisationId}/subscriptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name GetSubscriptionNextPayment
     * @request GET:/organisations/{organisationId}/subscriptions/next-payment
     * @secure
     */
    getSubscriptionNextPayment: (organisationId: string, params: RequestParams = {}) =>
      this.request<SubscriptionNextPayment, any>({
        path: `/organisations/${organisationId}/subscriptions/next-payment`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name GetRemainingAmount
     * @request GET:/organisations/{organisationId}/subscriptions/remaining-amount
     * @secure
     */
    getRemainingAmount: (organisationId: string, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/organisations/${organisationId}/subscriptions/remaining-amount`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name GetVatRate
     * @request GET:/organisations/{organisationId}/subscriptions/vat-rate
     * @secure
     */
    getVatRate: (organisationId: string, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/organisations/${organisationId}/subscriptions/vat-rate`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name CreateSubscriptionOptionPaymentAndSubscription
     * @request POST:/organisations/{organisationId}/subscriptions/option-payment
     * @secure
     */
    createSubscriptionOptionPaymentAndSubscription: (
      organisationId: string,
      data: SubscriptionOptionPaymentAndSubscriptionCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<SubscriptionOptionPaymentAndSubscriptionCreateResponse | null, any>({
        path: `/organisations/${organisationId}/subscriptions/option-payment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name CancelSubscriptionOptionSubscription
     * @request POST:/organisations/{organisationId}/subscriptions/cancel-subscription
     * @secure
     */
    cancelSubscriptionOptionSubscription: (organisationId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/subscriptions/cancel-subscription`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name DownloadInvoice
     * @request GET:/organisations/{organisationId}/subscriptions/download-invoice/{paymentId}
     * @secure
     */
    downloadInvoice: (organisationId: string, paymentId: string, params: RequestParams = {}) =>
      this.request<ExpressMulterFile, any>({
        path: `/organisations/${organisationId}/subscriptions/download-invoice/${paymentId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  trainings = {
    /**
     * No description
     *
     * @tags Trainings
     * @name GetCourses
     * @request GET:/organisations/{organisationId}/trainings/courses
     * @secure
     */
    getCourses: (organisationId: string, params: RequestParams = {}) =>
      this.request<Course[], any>({
        path: `/organisations/${organisationId}/trainings/courses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name CreateCourse
     * @request POST:/organisations/{organisationId}/trainings/courses
     * @secure
     */
    createCourse: (organisationId: string, data: CourseCreateRequest, params: RequestParams = {}) =>
      this.request<Course, any>({
        path: `/organisations/${organisationId}/trainings/courses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name ReorderCourses
     * @request PUT:/organisations/{organisationId}/trainings/courses/order
     * @secure
     */
    reorderCourses: (organisationId: string, data: ReorderRequest, params: RequestParams = {}) =>
      this.request<Course[], any>({
        path: `/organisations/${organisationId}/trainings/courses/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name UpdateCourse
     * @request PUT:/organisations/{organisationId}/trainings/courses/{courseId}
     * @secure
     */
    updateCourse: (organisationId: string, courseId: string, data: CourseUpdateRequest, params: RequestParams = {}) =>
      this.request<Course, any>({
        path: `/organisations/${organisationId}/trainings/courses/${courseId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name DeleteCourse
     * @request DELETE:/organisations/{organisationId}/trainings/courses/{courseId}
     * @secure
     */
    deleteCourse: (organisationId: string, courseId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/trainings/courses/${courseId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name GetModules
     * @request GET:/organisations/{organisationId}/trainings/courses/{courseId}/modules
     * @secure
     */
    getModules: (organisationId: string, courseId: string, params: RequestParams = {}) =>
      this.request<Module[], any>({
        path: `/organisations/${organisationId}/trainings/courses/${courseId}/modules`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name CreateModule
     * @request POST:/organisations/{organisationId}/trainings/courses/{courseId}/modules
     * @secure
     */
    createModule: (organisationId: string, courseId: string, data: ModuleCreateRequest, params: RequestParams = {}) =>
      this.request<Module, any>({
        path: `/organisations/${organisationId}/trainings/courses/${courseId}/modules`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name ReorderModules
     * @request PUT:/organisations/{organisationId}/trainings/courses/{courseId}/modules/order
     * @secure
     */
    reorderModules: (organisationId: string, courseId: string, data: ReorderRequest, params: RequestParams = {}) =>
      this.request<Module[], any>({
        path: `/organisations/${organisationId}/trainings/courses/${courseId}/modules/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name UpdateModule
     * @request PUT:/organisations/{organisationId}/trainings/courses/{courseId}/modules/{moduleId}
     * @secure
     */
    updateModule: (
      organisationId: string,
      courseId: string,
      moduleId: string,
      data: ModuleUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<Module, any>({
        path: `/organisations/${organisationId}/trainings/courses/${courseId}/modules/${moduleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trainings
     * @name DeleteModule
     * @request DELETE:/organisations/{organisationId}/trainings/courses/{courseId}/modules/{moduleId}
     * @secure
     */
    deleteModule: (organisationId: string, courseId: string, moduleId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organisations/${organisationId}/trainings/courses/${courseId}/modules/${moduleId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  treatmentAnalysis = {
    /**
     * No description
     *
     * @tags TreatmentAnalysis
     * @name Generate
     * @request POST:/organisations/{organisationId}/salons/{salonId}/treatment-analysis
     * @secure
     */
    generate: (organisationId: string, salonId: string, data: TreatmentAnalysisRequest, params: RequestParams = {}) =>
      this.request<TreatmentAnalysisResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/treatment-analysis`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TreatmentAnalysis
     * @name GenerateBatch
     * @request POST:/organisations/{organisationId}/salons/{salonId}/treatment-analysis/batch
     * @secure
     */
    generateBatch: (organisationId: string, salonId: string, data: TreatmentAnalysisBatchRequest, params: RequestParams = {}) =>
      this.request<TreatmentAnalysisBatchResult, any>({
        path: `/organisations/${organisationId}/salons/${salonId}/treatment-analysis/batch`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  upload = {
    /**
     * No description
     *
     * @tags Upload
     * @name UploadImage
     * @request POST:/organisations/{organisationId}/upload/images
     * @secure
     */
    uploadImage: (
      organisationId: string,
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadedItem, any>({
        path: `/organisations/${organisationId}/upload/images`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadPdf
     * @request POST:/organisations/{organisationId}/upload/pdf
     * @secure
     */
    uploadPdf: (
      organisationId: string,
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadedItem, any>({
        path: `/organisations/${organisationId}/upload/pdf`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadGlobalImage
     * @request POST:/upload/images
     * @secure
     */
    uploadGlobalImage: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadedItem, any>({
        path: `/upload/images`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadAudio
     * @request POST:/organisations/{organisationId}/upload/audio
     * @secure
     */
    uploadAudio: (
      organisationId: string,
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadedItem, any>({
        path: `/organisations/${organisationId}/upload/audio`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadFile
     * @request POST:/organisations/{organisationId}/upload/file
     * @secure
     */
    uploadFile: (
      organisationId: string,
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadedItem, any>({
        path: `/organisations/${organisationId}/upload/file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadGlobalFile
     * @request POST:/upload/file
     * @secure
     */
    uploadGlobalFile: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadedItem, any>({
        path: `/upload/file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name UploadGlobalAudio
     * @request POST:/upload/audio
     * @secure
     */
    uploadGlobalAudio: (
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UploadedItem, any>({
        path: `/upload/audio`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Upload
     * @name GetGlobalImagesCategories
     * @request GET:/images/categories
     * @secure
     */
    getGlobalImagesCategories: (params: RequestParams = {}) =>
      this.request<ImagesCategoriesTree, any>({
        path: `/images/categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userManuals = {
    /**
     * No description
     *
     * @tags User manuals
     * @name GetCourses
     * @request GET:/user-manuals/courses
     * @secure
     */
    getCourses: (params: RequestParams = {}) =>
      this.request<Course[], any>({
        path: `/user-manuals/courses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name CreateCourse
     * @request POST:/user-manuals/courses
     * @secure
     */
    createCourse: (data: CourseCreateRequest, params: RequestParams = {}) =>
      this.request<Course, any>({
        path: `/user-manuals/courses`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name ReorderCourses
     * @request PUT:/user-manuals/courses/order
     * @secure
     */
    reorderCourses: (data: ReorderRequest, params: RequestParams = {}) =>
      this.request<Course[], any>({
        path: `/user-manuals/courses/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name UpdateCourse
     * @request PUT:/user-manuals/courses/{courseId}
     * @secure
     */
    updateCourse: (courseId: string, data: CourseUpdateRequest, params: RequestParams = {}) =>
      this.request<Course, any>({
        path: `/user-manuals/courses/${courseId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name DeleteCourse
     * @request DELETE:/user-manuals/courses/{courseId}
     * @secure
     */
    deleteCourse: (courseId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-manuals/courses/${courseId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name GetModules
     * @request GET:/user-manuals/courses/{courseId}/modules
     * @secure
     */
    getModules: (courseId: string, params: RequestParams = {}) =>
      this.request<Module[], any>({
        path: `/user-manuals/courses/${courseId}/modules`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name CreateModule
     * @request POST:/user-manuals/courses/{courseId}/modules
     * @secure
     */
    createModule: (courseId: string, data: ModuleCreateRequest, params: RequestParams = {}) =>
      this.request<Module, any>({
        path: `/user-manuals/courses/${courseId}/modules`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name ReorderModules
     * @request PUT:/user-manuals/courses/{courseId}/modules/order
     * @secure
     */
    reorderModules: (courseId: string, data: ReorderRequest, params: RequestParams = {}) =>
      this.request<Module[], any>({
        path: `/user-manuals/courses/${courseId}/modules/order`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name UpdateModule
     * @request PUT:/user-manuals/courses/{courseId}/modules/{moduleId}
     * @secure
     */
    updateModule: (courseId: string, moduleId: string, data: ModuleUpdateRequest, params: RequestParams = {}) =>
      this.request<Module, any>({
        path: `/user-manuals/courses/${courseId}/modules/${moduleId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User manuals
     * @name DeleteModule
     * @request DELETE:/user-manuals/courses/{courseId}/modules/{moduleId}
     * @secure
     */
    deleteModule: (courseId: string, moduleId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-manuals/courses/${courseId}/modules/${moduleId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  whatsappCredits = {
    /**
     * No description
     *
     * @tags Whatsapp credits
     * @name CreateWhatsappCreditsPayment
     * @request POST:/organisations/{organisationId}/whatsapp-credits/credit-payment
     * @secure
     */
    createWhatsappCreditsPayment: (
      organisationId: string,
      data: WhatsappCreditsPaymentCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WhatsappCreditsPaymentCreateResponse, any>({
        path: `/organisations/${organisationId}/whatsapp-credits/credit-payment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Whatsapp credits
     * @name GetWhatsappCreditsOptions
     * @request GET:/organisations/{organisationId}/whatsapp-credits/options
     * @secure
     */
    getWhatsappCreditsOptions: (organisationId: string, params: RequestParams = {}) =>
      this.request<WhatsappCreditsOption[], any>({
        path: `/organisations/${organisationId}/whatsapp-credits/options`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
